/* Area do cliente (/pages/conta). Carrega SO neste template (budget proprio de
 * 24KB minificado; gate em scripts/check-js-budget.mjs). Port fiel do prototipo
 * r02 do design (reference/perfil-cliente/). Identidade e dados via App Proxy
 * assinado pela Shopify (/apps/curador/conta/*). Deslogado = CTA de login (nunca
 * erro). Render por clonagem de <template> + DOM API (nunca innerHTML de dado).
 * Estrutura HTML e strings estaticas vivem na section; aqui so a logica. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mw-conta]');
  if (!root) return;
  /* O `| t` da Shopify escapa as aspas do texto para &quot; (e ' & < > para
     entidades), e o texto vai para a tela por textContent, que nao as desfaz:
     o toast mostrava Removi &quot;...&quot; (R30, ponto 2). O desent desfaz na
     leitura, numa passada so e so em string. Nada deste bloco vai para
     innerHTML. O gate scripts/check-i18n-entidade.mjs confere que este leitor
     chama o desent; a mesma funcao vive no assets/mw-evento.js. */
  function desent(k, v) {
    return typeof v == 'string' ? v.replace(/&(quot|#39|#x27|lt|gt|amp);/g, function (m, e) {
      return { quot: '"', lt: '<', gt: '>', amp: '&' }[e] || "'";
    }) : v;
  }
  var i18n = document.getElementById('mw-conta-i18n');
  var T = {};
  try { T = JSON.parse(i18n.textContent, desent); } catch (e) { return; }
  var API = '/apps/curador/conta';
  var LOGIN = root.getAttribute('data-login-url') || '';
  var HOSTED = root.getAttribute('data-hosted-url') || '';
  var palco = root.querySelector('[data-mwc-palco]');

  var MES_LONGO = (T.meses_longo || '').split(',');
  var MES_CURTO = (T.meses_curto || '').split(',');
  var CAT_CLS = { gosto: 'mwc-fato-gosto', restricao: 'mwc-fato-restricao', contexto: 'mwc-fato-contexto' };
  /* T8-8 (dono, 31/10): a resposta ao email "gostou?" diz de onde veio */
  var ORIG_ROT = { conta: T.origem_conta, curador: T.origem_curador, painel: T.origem_painel, resposta_email: T.origem_resposta_email };
  var QUIZ_CAT = ['contexto', 'gosto', 'contexto', 'restricao'];
  /* a colecao de cada ocasiao, a mesma do botao do email (COLECAO_DO_TIPO do painel) */
  var COL_TIPO = { aniversario: '/collections/aniversario', casamento: '/collections/casal' };

  var fmtBRL = (function () {
    try { var f = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }); return function (n) { return f.format(Number(n) || 0); }; }
    catch (e) { return function (n) { return 'R$ ' + (Number(n) || 0).toFixed(2).replace('.', ','); }; }
  })();

  /* ---------- estado ---------- */
  var st = {
    loaded: false, nome: '', perfil: null,
    presenteados: [], datas: [], pedidos: [], fatos: [], conversas: [],
    view: 'painel', dossieId: null, vincAberto: null,
    overlay: null, modal: null, quiz: null
  };
  var pendentes = {}; // key -> { path } (DELETEs adiados a confirmar no pagehide)
  var apagadas = {}; // key -> 1 do DELETE adiado que saiu (sai daqui se ele falha)
  var contentEl = null;

  /* ---------- helpers de template/dom ---------- */
  function tpl(name) { return root.querySelector('template[data-tpl="' + name + '"]'); }
  function clone(name) { return tpl(name).content.firstElementChild.cloneNode(true); }
  function slot(node, name) { return node.querySelector('[data-slot="' + name + '"]'); }
  function setText(node, name, txt) { var s = slot(node, name); if (s) s.textContent = txt == null ? '' : txt; }
  function cond(node, name, on) { var e = node.querySelector('[data-slot-if="' + name + '"]'); if (e) e.hidden = !on; return e; }
  function fmt(str, map) { return (str || '').replace(/%(\w+)/g, function (_, k) { return map[k] != null ? map[k] : ''; }); }
  /* /conta/conversas manda handles; quando o backend nao sabe o nome, o handle legivel */
  function nomeDoHandle(h) { return String(h || '').split('-').map(function (p) { return p.charAt(0).toUpperCase() + p.slice(1); }).join(' '); }
  function iniciais(nome) { return (nome || '?').trim().charAt(0).toUpperCase(); }
  function rel(p) { return p.relacao && p.relacao !== 'presenteado' ? p.relacao : ''; }
  function thumbImg(box, url, titulo) { if (url) { var img = new Image(); img.src = url; img.alt = (T.alt_garrafa || '') + ' ' + titulo; img.loading = 'lazy'; box.appendChild(img); } }
  function G(e, n) { return e.getAttribute(n); }
  function S(e, n, v) { e.setAttribute(n, v); }
  function mk(tag, cls, txt) { var n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; }
  function byId(a, id) { for (var i = 0; i < a.length; i++) if (a[i].id === id) return a[i]; return null; }
  function readF(scope, field) { var el = scope.querySelector('[data-field="' + field + '"]'); return el ? String(el.value).trim() : ''; }
  function setF(scope, field, v) { var el = scope.querySelector('[data-field="' + field + '"]'); if (el) el.value = v == null ? '' : v; }
  /* semFoco: o aviso que aparece sem a pessoa pedir (a troca do Mes, a saida do
     Dia) nao move o foco, porque isso seria mudanca de contexto (WCAG 3.2.2) */
  function fieldErro(scope, field, msg, semFoco) {
    var el = scope.querySelector('[data-field="' + field + '"]'), er = scope.querySelector('[data-field-erro="' + field + '"]');
    if (msg) { if (el) S(el, 'aria-invalid', 'true'); if (er) { er.textContent = msg; er.hidden = false; } if (el && !semFoco) el.focus(); }
    else { if (el) el.removeAttribute('aria-invalid'); if (er) { er.textContent = ''; er.hidden = true; } }
  }

  /* ---------- datas ---------- */
  function fData(iso) { var d = new Date(iso); return d.getDate() + ' ' + (MES_CURTO[d.getMonth()] || '') + ' ' + d.getFullYear(); }
  /* T6-5b (dono, 31/10): o mes no meio da frase vai com minuscula ("12 de marco");
     o seletor de mes da janela de data le meses_longo direto no Liquid e segue "Marco" */
  function fDiaMes(dia, mes) { return dia + ' de ' + (MES_LONGO[mes - 1] || '').toLowerCase(); }
  /* T7-6 (dono, 01/11): a data nao tem ano, entao fevereiro vai ate 29 */
  function diasNoMes(mes) { return [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][mes - 1]; }
  /* T7-6: no ano sem dia 29, o 29/02 conta ate o dia 28, como o email
     (normalizarOcorrencia, painel/src/lib/nudges/tempo.ts); o new Date(a, 1, 29)
     que cai em marco diz que o ano nao tem o 29. desde (opcional, a meia-noite): a
     primeira a partir dele quando ele vem depois de hoje; dias segue contado de hoje */
  function proxData(dia, mes, desde) {
    var h = new Date(); h = new Date(h.getFullYear(), h.getMonth(), h.getDate());
    var a = desde > h ? desde : h;
    function em(y) { return new Date(y, mes - 1, mes === 2 && dia === 29 && new Date(y, 1, 29).getMonth() !== 1 ? 28 : dia); }
    var d = em(a.getFullYear());
    if (d < a) d = em(a.getFullYear() + 1);
    return { data: d, dias: Math.round((d - h) / 86400000) };
  }
  function proxLabel(dia, mes) {
    var p = proxData(dia, mes);
    if (p.dias === 0) return T.prox_hoje;
    if (p.dias === 1) return T.prox_amanha;
    if (p.dias <= 45) return fmt(T.prox_dias, { n: p.dias });
    return p.data.getDate() + ' ' + (MES_CURTO[p.data.getMonth()] || '') + ' ' + p.data.getFullYear();
  }
  function statusInfo(s) {
    var m = {
      processando: { r: T.status_processando, c: 'mwc-dot-ambar' },
      despachado: { r: T.status_despachado, c: 'mwc-dot-ambar' },
      entregue: { r: T.status_entregue, c: 'mwc-dot-verde' },
      cancelado: { r: T.status_cancelado, c: 'mwc-dot-apagado' }
    };
    return m[s] || { r: s || '', c: 'mwc-dot-ambar' };
  }
  function endGrande(e) {
    if (!e) return '';
    var rua = e.rua || e.endereco1 || '';
    var comp = e.complemento || e.endereco2 || '';
    var l = rua + (comp ? ', ' + comp : '');
    return l + ' - ' + (e.cidade || '') + '/' + (e.uf || '') + ' - ' + (e.cep || '');
  }
  function plural(base, n) {
    if (n === 0 && T[base + '_zero'] != null) return T[base + '_zero'];
    var k = n === 1 && T[base + '_one'] != null ? '_one' : '_other';
    return fmt(T[base + k], { n: n });
  }

  /* ---------- rede ---------- */
  function req(method, path, body) {
    return fetch(API + path, {
      method: method,
      headers: body ? { 'Content-Type': 'application/json' } : undefined,
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { j._ok = r.ok; j._status = r.status; return j; });
    });
  }

  /* ---------- toast (J35: 7s com acao, pausa no hover/focus, fechar manual) ---------- */
  var toastEl = null, toastTimer = null;
  function toast(txt, opts) {
    opts = opts || {};
    /* o aviso novo efetiva o que o aviso que ele tira deixou pendente (o apagar com
       DESFAZER, como nos desfazer de mercado): o DELETE sai agora, nao no pagehide, e
       um GET /datas no meio nao traz a data de volta; o DESFAZER dele deixa de valer */
    limparToast(true);
    var n = clone('toast');
    S(n, 'role', opts.erro ? 'alert' : 'status'); // a11y (spec 5): erro assertivo, sucesso polido
    S(n, 'aria-live', opts.erro ? 'assertive' : 'polite');
    if (opts.erro) { S(n, 'data-erro', ''); cond(n, 'erro', true); } else cond(n, 'erro', false);
    setText(n, 'texto', txt);
    if (opts.acao) { cond(n, 'acao', true); setText(n, 'acao-rot', opts.acaoRot); n._acao = opts.acao; } else cond(n, 'acao', false);
    n._expira = opts.onExpire || null;
    /* fixo (H3, 31/10): sem o x e sem prazo; fica ate a pessoa agir (T27-2b dos eventos) */
    if (opts.fixo) n.querySelector('[data-act="toast-fechar"]').hidden = true;
    root.appendChild(n); toastEl = n;
    if (opts.fixo) { clearTimeout(toastTimer); return; } // o focusout do aviso que saiu reagenda o prazo dele
    var dur = opts.dur || (opts.erro || opts.acao ? 7000 : 4200);
    var restante = dur, inicio = Date.now(), pausado = false;
    function agenda(ms) { clearTimeout(toastTimer); inicio = Date.now(); toastTimer = setTimeout(function () { limparToast(true); }, ms); }
    function pausa() { if (pausado) return; pausado = true; restante -= Date.now() - inicio; clearTimeout(toastTimer); }
    function retoma() { if (!pausado) return; pausado = false; agenda(restante); }
    n.addEventListener('mouseenter', pausa); n.addEventListener('mouseleave', retoma);
    n.addEventListener('focusin', pausa); n.addEventListener('focusout', retoma);
    agenda(dur);
  }
  /* o onExpire roda uma vez so: sai do aviso antes de rodar (vencimento, x, troca) */
  function limparToast(expirou) {
    clearTimeout(toastTimer);
    var n = toastEl, f = n && expirou && n._expira;
    if (!n) return;
    n._expira = null; toastEl = null; n.remove();
    if (f) f();
  }
  /* O aviso de uma escrita que falhou. A sessao que venceu no meio do uso (H3,
     31/10: o 401 nao_logado do guard da conta, painel/src/lib/conta/guard.ts) nao
     tem TENTAR DE NOVO, que so levaria outro 401: o aviso fixo diz que a ultima
     mudanca nao foi salva e leva ao login, de volta a vista aberta. O que estava
     na janela nao e guardado (decisao de 31/10: o caso e raro e o texto pede
     para refazer). O resto (rede, 5xx, as outras recusas) tem TENTAR DE NOVO. */
  function sessaoCaiu(r) { if (r && r._status === 401 && r.erro === 'nao_logado') avisoFalha(r); }
  function avisoFalha(r, fn) {
    if (r && r._status === 401 && r.erro === 'nao_logado') {
      if (st.oel) { if (st.quiz) fecharQuiz(); else fecharOverlay(); } // a janela nao salva mais nada e prenderia o Tab sob o aviso
      toast(T.sessao_caiu, { erro: true, fixo: true, acaoRot: T.acao_entrar, acao: entrar });
    }
    else toast(T.toast_erro_salvar, { erro: true, acaoRot: T.acao_tentar, acao: fn });
  }

  /* ---------- persistencia (J38) ----------
     Toda falha desfaz o que a tela adiantou e mostra o avisoFalha: TENTAR DE NOVO,
     que repete a chamada, para rede, 5xx e as outras recusas; a sessao vencida
     nao tem retentativa. */
  function persistir(fazer, aoFalhar) {
    return fazer().then(function (r) {
      if (!r || !r._ok) throw r || {};
      return r;
    }).catch(function (err) {
      if (aoFalhar) aoFalhar();
      avisoFalha(err, function () { persistir(fazer, aoFalhar); });
      throw err;
    });
  }

  /* ---------- carregar ---------- */
  function boot() {
    var skel = setTimeout(function () { if (!st.loaded && !st.dlm) skelPalco(); }, 500);
    req('GET', '/eu').then(function (r) {
      clearTimeout(skel);
      if (r && r._ok && r.logado === false) { mostrarDeslogado(); return; }
      if (!r || !r._ok) { st.nome = ''; falhaLoad(); return; }
      st.nome = r.nome || '';
      renderChrome(); // chrome com o nome ja aparece; o miolo vira esqueleto se o fetch atrasar
      carregarDados();
    }).catch(function () { clearTimeout(skel); st.nome = ''; falhaLoad(); });
  }

  /* Falha do PRIMEIRO load: 1 retry automatico com backoff curto (~2s), sem loop.
     Transitoria (rede/5xx generico) tenta de novo uma vez; 2a falha vira o estado de erro. */
  function falhaLoad() {
    if (st.rt) { renderChrome(); mostrarErroContent(); return; }
    st.rt = true; skelPalco(); setTimeout(boot, 2000);
  }

  function carregarDados() {
    if (st.busy) return; // um load por vez; troca de aba nunca dispara load concorrente
    st.busy = true;
    var skelTimer = setTimeout(function () { if (!st.loaded) skelContent(); }, 500); // J39: esqueleto so apos ~500ms
    Promise.all([
      req('GET', '/perfil'), req('GET', '/presenteados'), req('GET', '/datas'),
      req('GET', '/pedidos'), req('GET', '/memoria'), req('GET', '/conversas')
    ]).then(function (r) {
      clearTimeout(skelTimer); st.busy = false;
      var logout = false, off = false, bad = false;
      r.forEach(function (x) {
        if (x._ok) return;
        bad = true;
        if (x._status === 401 && x.erro === 'nao_logado') logout = true;
        if (x._status === 503 && x.erro === 'conta_desligada') off = true; // kill switch do backend
      });
      if (logout) { mostrarDeslogado(); return; }
      if (off) { renderChrome(); mostrarDesligada(); return; } // manutencao: estado calmo, nunca "erro"
      if (bad) { falhaLoad(); return; }
      st.perfil = r[0].perfil || { preferencias: {} };
      st.nome = st.perfil.nome || st.nome;
      st.presenteados = r[1].presenteados || [];
      st.datas = r[2].datas || [];
      st.pedidos = (r[3].pedidos || []).map(normalizarPedido);
      st.fatos = r[4].fatos || [];
      st.memLig = r[4].memoriaLigada === true;
      st.conversas = r[5].conversas || [];
      st.loaded = true;
      lerRota();
      renderChrome();
      renderView();
      if (!st.pedidos.length) iniciarPollPedidos();
    }).catch(function () { clearTimeout(skelTimer); st.busy = false; falhaLoad(); });
  }

  /* img, url, disponivel e precoAtual de cada item vem do BACKEND (contrato v2 de
     /conta/pedidos, lidos do cache do catalogo). O JSON inline #mw-catalogo saiu do
     tema: parava em 50 produtos e com 191 rotulos deixaria a maioria dos itens de
     pedido sem foto. Cache frio = esses campos null, e a linha degrada pro texto
     (nem "disponivel" nem "esgotado": null nao e resposta, e mentir e pior). */
  function normalizarPedido(o) {
    o.itens = o.itens || [];
    return o;
  }

  /* re-fetch leve no vazio de pedidos (J26): ~20s por ~2min */
  var pollN = 0, pollT = null;
  function iniciarPollPedidos() {
    if (pollT || pollN >= 6) return;
    pollT = setInterval(function () {
      pollN++;
      req('GET', '/pedidos').then(function (r) {
        if (r && r._ok && (r.pedidos || []).length) {
          st.pedidos = r.pedidos.map(normalizarPedido); pararPoll();
          if (st.view === 'painel' || st.view === 'pedidos') renderView();
        } else if (pollN >= 6) pararPoll();
      }).catch(function () { if (pollN >= 6) pararPoll(); });
    }, 20000);
  }
  function pararPoll() { if (pollT) { clearInterval(pollT); pollT = null; } }

  /* ---------- palco: deslogado / erro / esqueleto / chrome ---------- */
  function limpar(el) { while (el.firstChild) el.removeChild(el.firstChild); }
  /* H2 (31/10): a volta do login leva a vista aberta numa query (?v=pedidos,
     ?v=presenteados/<id>), nunca no #: a doc da Shopify nao garante o fragmento
     no return_to, e o redirect do login por codigo o perde (layout/theme.liquid).
     O Painel volta sem ?v. O LOGIN (snippets/login-url.liquid) termina em
     'return_to=': um return_to so. */
  function aqui() {
    var v = st.view === 'presenteados' && st.dossieId ? 'presenteados/' + encodeURIComponent(st.dossieId) : st.view;
    return location.pathname + (v !== 'painel' ? '?v=' + v : '');
  }
  function loginUrl() { return LOGIN ? LOGIN + encodeURIComponent(aqui()) : '#'; }
  /* ENTRAR DE NOVO (H3): o login de volta a esta vista, com o mw_ret no formato do
     snippets/marca-retorno.liquid ({ u: o return_to, t: agora }), que o script do
     head de layout/theme.liquid consome quando o Google descarta o return_to. Sem
     storage, o login segue do mesmo jeito. */
  function entrar() {
    try { localStorage.setItem('mw_ret', JSON.stringify({ u: aqui(), t: Date.now() })); } catch (e) {}
    location.href = loginUrl();
  }

  function skelPalco() { limpar(palco); palco.appendChild(clone('skeleton')); }
  function skelContent() { if (contentEl) { limpar(contentEl); contentEl.appendChild(clone('skeleton')); } }
  function mostrarErroContent() {
    if (!contentEl) return;
    limpar(contentEl);
    var e = clone('erro');
    var a = slot(e, 'erro-hosted'); if (a) a.href = HOSTED || '#';
    contentEl.appendChild(e);
  }
  function mostrarDesligada() { // conta_desligada (503): manutencao, no lugar do miolo
    pararPoll(); if (!contentEl) return;
    limpar(contentEl); contentEl.appendChild(clone('desligada'));
  }
  function mostrarDeslogado() {
    st.dlm = true; pararPoll();
    limpar(palco);
    var d = clone('deslogado');
    var link = slot(d, 'entrar-link'); if (link) link.href = loginUrl();
    palco.appendChild(d);
  }

  function renderChrome() {
    limpar(palco);
    var c = clone('chrome');
    setText(c, 'inicial', iniciais(st.nome));
    setText(c, 'nome', st.nome || '');
    var rh = slot(c, 'rail-hosted'); if (rh) rh.href = HOSTED || '#';
    contentEl = c.querySelector('[data-mwc-content]');
    palco.appendChild(c);
    marcarNav();
  }
  function marcarNav() {
    var nav = palco.querySelector('[data-mwc-nav]'); if (!nav) return;
    Array.prototype.forEach.call(nav.querySelectorAll('.mwc-nav-item'), function (b) {
      if (b.getAttribute('data-view') === st.view) b.setAttribute('aria-current', 'page');
      else b.removeAttribute('aria-current');
    });
  }

  /* ---------- roteamento (hash) ---------- */
  var VISTAS = { painel: 1, presenteados: 1, pedidos: 1, curador: 1, preferencias: 1 };
  /* H2: a volta do login chega com a vista em ?v= e ela vira o # por replaceState
     (sem entrada nova no historico), antes da porta e do primeiro desenho; o ?v
     invalido so sai, e vale o # que ja estava */
  function temVista(v) { return Object.prototype.hasOwnProperty.call(VISTAS, v); }
  function lerRota() {
    var h = (location.hash || '').replace(/^#/, ''), q = new URLSearchParams(location.search), v = q.get('v');
    if (v != null) {
      q.delete('v'); q = String(q);
      if (temVista(v) || /^presenteados\/./.test(v)) h = v;
      history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + (h ? '#' + h : ''));
    }
    var m = h.match(/^presenteados\/(.+)$/);
    if (m) { st.view = 'presenteados'; st.dossieId = m[1]; }
    else if (temVista(h)) { st.view = h; st.dossieId = null; }
    else { st.view = 'painel'; st.dossieId = null; }
  }
  /* vinc: o pedido que chega com o painel "Esse presente foi para..." aberto (T6-9) */
  function irVista(v, id, vinc) {
    st.view = v; st.dossieId = id || null; st.vincAberto = vinc || null; st.vincNova = null;
    var hash = v === 'presenteados' && id ? 'presenteados/' + id : v;
    if (('#' + hash) !== location.hash) { st._interno = true; location.hash = hash; }
    renderView(); marcarNav();
  }
  window.addEventListener('hashchange', function () {
    if (st._interno) { st._interno = false; return; }
    if (!st.loaded) return;
    lerRota(); renderView(); marcarNav();
  });

  /* T6-13 (dono, 31/10): o redesenho do painel do pedido devolve o foco ao
     controle tocado (chip, campo do nome); se ele sumiu (T6-12), ao primeiro da
     fileira. So dentro do painel: fora dele, o X de outra linha herdaria o foco
     do X apagado. */
  function chaveFoco(e) { return (G(e, 'data-act') || G(e, 'data-field')) + (G(e, 'data-pid') || G(e, 'data-did') || ''); }
  function setContent(node) {
    if (!contentEl) return;
    var a = document.activeElement, k = a && a.closest && a.closest('.mwc-vincular') ? chaveFoco(a) : null;
    limpar(contentEl); contentEl.appendChild(node);
    var box = k && contentEl.querySelector('.mwc-vinc-painel');
    if (!box) return;
    var c = box.querySelectorAll('[data-act],[data-field]'), f = c[0];
    for (var i = 0; i < c.length; i++) if (c[i].offsetParent && chaveFoco(c[i]) === k) { f = c[i]; break; }
    if (f) f.focus({ preventScroll: true });
  }
  /* foco num controle do cartao do pedido; rolar = o painel ao centro (T6-9) */
  function focoEm(id, sel, rolar) {
    var c = contentEl ? contentEl.querySelectorAll('.mwc-ped') : [];
    for (var i = 0; i < c.length; i++) if (G(c[i], 'data-id') === id) {
      var k = c[i].querySelector(sel);
      if (rolar) c[i].querySelector('.mwc-vincular').scrollIntoView({ block: 'center' });
      if (k) k.focus({ preventScroll: !!rolar });
    }
  }

  /* ---------- render por vista ---------- */
  function renderView() {
    if (!contentEl) return;
    // dados ainda nao chegaram (erro/carregando): a troca de aba NUNCA renderiza o vazio
    // default; re-mostra o carregando e re-tenta o load (guardado por st.busy, sem duplicar).
    if (!st.loaded) { skelContent(); carregarDados(); return; }
    if (st.view === 'presenteados' && st.dossieId) return renderDossie();
    ({ painel: renderPainel, presenteados: renderLista, pedidos: renderPedidos, curador: renderCurador, preferencias: renderPrefs }[st.view] || renderPainel)();
  }

  function acharP(id) { return st.presenteados.filter(function (p) { return p.id === id; })[0] || null; }
  /* T6-14: o pedido de onde veio a ficha aberta, so quando ela e da mesma pessoa */
  function voltaPed() { var v = st.volta; return v && v.p === st.dossieId && byId(st.pedidos, v.o) ? v.o : null; }
  function datasDe(id) { return st.datas.filter(function (d) { return d.presenteadoId === id; }); }
  /* T6-10 e T6-11 (dono, 31/10): o pedido cancelado nao chegou a ninguem e o de
     varios enderecos tem uma pessoa por remessa; nenhum dos dois tem a linha de
     para quem foi nem conta nos presentes da pessoa (lista, contador, Repetir do radar) */
  function semPessoa(o) { return o.cancelado || o.statusEntrega === 'cancelado' || o.variosDestinos === true; }
  function pedidoDe(id) { return st.pedidos.filter(function (o) { return o.presenteadoId === id && !semPessoa(o); }); }
  /* T8-1d, T8-6 e T8-12 (dono, 31/10): ja respondeu = tem resposta das 4 perguntas
     (origem conta); a resposta ao "gostou?" nao conta */
  function respondeu(id) { return st.fatos.some(function (f) { return f.presenteadoId === id && f.origem === 'conta'; }); }

  /* ---------- Painel ---------- */
  function renderPainel() {
    var v = clone('painel');
    setText(v, 'saudacao', st.nome ? fmt(T.painel_saudacao, { n: st.nome }) : T.saud_sem_nome);
    var ultimo = st.pedidos[0] || null;
    var proximas = radarLinhas();
    var temUltimo = !!ultimo;
    var mostrarRadar = temUltimo || proximas.length > 0;
    var vazio = !temUltimo && proximas.length === 0;

    cond(v, 'ultimo', temUltimo);
    if (temUltimo) montarUltimo(v, ultimo);
    cond(v, 'radar', mostrarRadar);
    if (mostrarRadar) {
      var lista = slot(v, 'radar-lista');
      proximas.forEach(function (row) { lista.appendChild(row); });
      cond(v, 'radar-vazio', proximas.length === 0);
    }
    cond(v, 'vazio', vazio);
    cond(v, 'loja', !vazio); // T3.2: no vazio, o "Ver os vinhos" do cartao ja leva a loja

    setText(v, 'resumo-presenteados', plural('resumo_presenteados', st.presenteados.length));
    setText(v, 'resumo-pedidos', plural('resumo_pedidos', st.pedidos.length));
    /* T8-1c: com a memoria ligada, a linha do nome e a dos pedidos do bloco "Voce" contam */
    var nm = st.fatos.length + (st.memLig ? !!st.nome + !!nPed() : 0);
    setText(v, 'resumo-memoria', nm ? fmt(nm === 1 ? T.rm1 : T.rmo, { n: nm }) : T.rmz);
    setContent(v);
    if (vazio) iniciarPollPedidos();
  }

  function montarUltimo(v, o) {
    setText(v, 'ultimo-numero', o.numero);
    var si = statusInfo(o.statusEntrega);
    var dot = slot(v, 'ultimo-dot'); if (dot) dot.className = 'mwc-status-dot ' + si.c;
    setText(v, 'ultimo-status', si.r);
    var itens = slot(v, 'ultimo-itens');
    o.itens.forEach(function (it) {
      var w = clone('ultimo-item'); thumbImg(slot(w, 'thumb'), it.img, it.titulo);
      setText(w, 'titulo', it.titulo); setText(w, 'linha', itemLinhaTxt(it)); itens.appendChild(w);
    });
    var tot = clone('ultimo-total'); setText(tot, 'val', fmtBRL(o.total)); itens.appendChild(tot);
    var acoes = slot(v, 'ultimo-acoes');
    if (o.itens.some(function (it) { return it.disponivel; })) {
      var b = mk('button', 'mwc-btn mwc-btn-primario', T.repetir_presente); b.type = 'button'; S(b, 'data-act', 'repetir-pedido'); S(b, 'data-id', o.id); acoes.appendChild(b);
    }
    var a = mk('a', 'mwc-btn mwc-btn-linha', T.rastreio_nota); a.href = o.urlOficial || HOSTED || '#'; acoes.appendChild(a);
    if (semPessoa(o)) return;
    var alvo = o.presenteadoId ? acharP(o.presenteadoId) : null;
    if (alvo) acoes.appendChild(mk('span', 'mwc-btn-vinc-info', fmt(T.pra_nome, { n: alvo.nome })));
    else { var d = mk('button', 'mwc-btn-vinc-dash', T.foi_pra_quem); d.type = 'button'; S(d, 'data-act', 'vincular-de-painel'); S(d, 'data-id', o.id); acoes.appendChild(d); }
  }

  function radarLinhas() {
    var linhas = st.datas.map(function (d) {
      var p = proxData(d.dia, d.mes);
      var alvo = d.presenteadoId ? acharP(d.presenteadoId) : null;
      var ped = alvo ? pedidoDe(alvo.id)[0] : null;
      var item = ped ? ped.itens.filter(function (it) { return it.disponivel; })[0] : null;
      return { d: d, ordem: p.dias, item: item };
    }).sort(function (a, b) { return a.ordem - b.ordem; });
    return linhas.map(function (x) {
      var d = x.d;
      var r = clone('radar-row');
      r.setAttribute('data-id', d.id);
      setText(r, 'dia', String(d.dia).padStart(2, '0'));
      setText(r, 'mes', (MES_CURTO[d.mes - 1] || '').toUpperCase());
      setText(r, 'titulo', d.titulo);
      setText(r, 'quando', proxLabel(d.dia, d.mes));
      cond(r, 'tem-presente', !!x.item);
      /* T7-10 (dono, 31/10): o "ESCOLHER ->" leva a colecao da ocasiao; sem destino, todos os vinhos */
      var esc = cond(r, 'sem-presente', !x.item);
      if (COL_TIPO[d.tipo]) S(esc, 'data-destino', COL_TIPO[d.tipo]);
      if (x.item) {
        var b = r.querySelector('[data-act="repetir-radar"]');
        b.textContent = fmt(T.repetir_nome, { n: (x.item.titulo.split(' ')[0] || '').toUpperCase() });
        b.setAttribute('data-vid', x.item.variantId); b.setAttribute('data-titulo', x.item.titulo); b.setAttribute('data-handle', x.item.handle || '');
      }
      return r;
    });
  }

  /* ---------- Presenteados (lista) ---------- */
  function renderLista() {
    var v = clone('lista');
    if (st.form) slot(v, 'form-host').appendChild(montarForm());
    var vazio = st.presenteados.length === 0 && !st.form;
    cond(v, 'vazio', vazio);
    cond(v, 'add-topo', st.presenteados.length > 0); // T4.2: volta com a primeira pessoa, no proximo render
    var cards = slot(v, 'cards');
    st.presenteados.forEach(function (p) { cards.appendChild(montarPCard(p)); });
    setContent(v);
  }

  function montarPCard(p) {
    var c = clone('p-card');
    c.setAttribute('data-id', p.id);
    setText(c, 'inicial', iniciais(p.nome));
    setText(c, 'nome', p.nome);
    setText(c, 'relacao', rel(p));
    var nPres = pedidoDe(p.id).length;
    setText(c, 'resumo', plural('card_presentes', nPres));
    var ds = datasDe(p.id).slice().sort(function (a, b) { return proxData(a.dia, a.mes).dias - proxData(b.dia, b.mes).dias; });
    var prox = ds[0];
    cond(c, 'proxima', !!prox);
    if (prox) setText(c, 'proxima', prox.titulo + ' · ' + proxLabel(prox.dia, prox.mes));
    return c;
  }

  /* ---------- Form presenteado ---------- */
  function montarForm() {
    var f = clone('form');
    var edit = st.form.editId ? acharP(st.form.editId) : null;
    setText(f, 'form-titulo', edit ? fmt(T.form_editar_titulo, { n: (edit.nome || '').toUpperCase() }) : T.form_novo_titulo);
    setText(f, 'form-salvar-rot', edit ? T.salvar_mudancas : T.salvar);
    /* T8-1c: com a memoria ligada, as notas vao ao Curador, e o rotulo diz isso */
    if (st.memLig) setText(f, 'notas-rot', T.f_notas_curador);
    if (edit) {
      val(f, 'nome', edit.nome);
      val(f, 'relacao', rel(edit));
      val(f, 'email', edit.email || '');
      val(f, 'notas', (edit.notas && edit.notas !== T.sem_notas) ? edit.notas : '');
      var e = edit.endereco;
      if (e) {
        cond(f, 'end-fechado', false); cond(f, 'end-aberto', true);
        val(f, 'rua', e.rua || e.endereco1 || '');
        val(f, 'cidade', e.cidade || ''); val(f, 'uf', e.uf || ''); val(f, 'cep', e.cep || '');
        var comp = e.complemento || e.endereco2 || '';
        if (comp) { cond(f, 'comp-aberto', true); cond(f, 'comp-fechado', false); val(f, 'complemento', comp); }
      }
    }
    return f;
  }
  function val(scope, field, value) { setF(scope, field, value); }
  function getVal(field) { return readF(contentEl, field); }
  function campoErro(field, msg) { fieldErro(contentEl, field, msg); }

  function salvarPresenteado() {
    var nome = getVal('nome');
    campoErro('nome', '');
    if (!nome) { campoErro('nome', T.val_nome); return; } // J38: validacao inline
    var end = montarEndereco();
    var dados = {
      nome: nome, relacao: getVal('relacao') || null, email: getVal('email') || null,
      notas: getVal('notas') || null, endereco: end
    };
    var editId = st.form.editId;
    if (editId) {
      var p = acharP(editId); var antes = {};
      Object.keys(dados).forEach(function (k) { antes[k] = p[k]; p[k] = dados[k]; });
      st.form = null; renderView();
      persistir(function () { return req('PUT', '/presenteados/' + editId, dados); },
        function () { Object.keys(antes).forEach(function (k) { p[k] = antes[k]; }); renderView(); });
      toast(T.toast_mudancas);
    } else {
      var tmp = { id: 'tmp_' + Date.now(), nome: dados.nome, relacao: dados.relacao, email: dados.email, notas: dados.notas, endereco: dados.endereco };
      st.presenteados.push(tmp); st.form = null; irVista('presenteados', tmp.id);
      persistir(function () { return req('POST', '/presenteados', dados); }, function () {
        st.presenteados = st.presenteados.filter(function (x) { return x !== tmp; }); if (st.dossieId === tmp.id) irVista('presenteados');
      }).then(function (r) { if (r && r.id) { tmp.id = r.id; if (st.dossieId) st.dossieId = r.id; } });
      toast(fmt(T.toast_novo_presenteado, { n: nome }));
    }
  }
  function montarEndereco() {
    var rua = getVal('rua'), comp = getVal('complemento'), cidade = getVal('cidade'), uf = getVal('uf').toUpperCase(), cep = getVal('cep');
    if (!rua && !comp && !cidade && !uf && !cep) return null;
    var e = {};
    if (rua) e.rua = rua; if (comp) e.complemento = comp; if (cidade) e.cidade = cidade; if (uf) e.uf = uf; if (cep) e.cep = cep;
    return e;
  }

  /* ---------- Dossie ---------- */
  function renderDossie() {
    var p = acharP(st.dossieId);
    if (!p) { irVista('presenteados'); return; }
    var v = clone('dossie');
    if (voltaPed()) setText(v, 'voltar-rot', T.nav_pedidos); // T6-14: aberta pelo link do pedido
    setText(v, 'inicial', iniciais(p.nome));
    setText(v, 'nome', p.nome);
    setText(v, 'relacao', rel(p));
    setText(v, 'notas', p.notas || T.sem_notas);
    /* T5.2 (dono, 29/10): "Sem email cadastrado." para toda pessoa sem email; a
       versao longa, que prometia o email do presente, saiu, e com ela a curta da
       pessoa que veio de um evento (semEmailPresente), que dizia o mesmo */
    cond(v, 'tem-email', !!p.email); cond(v, 'sem-email', !p.email);
    if (p.email) setText(v, 'email', p.email);
    cond(v, 'tem-endereco', !!p.endereco);
    if (p.endereco) setText(v, 'endereco', endGrande(p.endereco));

    setText(v, 'datas-titulo', fmt(T.datas_de, { n: (p.nome || '').toUpperCase() }));
    var ds = datasDe(p.id);
    var dl = slot(v, 'datas');
    ds.forEach(function (d) { dl.appendChild(montarDataRow(d)); });
    cond(v, 'sem-datas', ds.length === 0);
    /* T5.4: o "+ ADICIONAR DATA" do cabecalho so com data; a primeira salva repinta a ficha e ele volta */
    cond(v, 'add-data-topo', ds.length > 0);

    var gifts = [];
    pedidoDe(p.id).forEach(function (o) { o.itens.forEach(function (it) { gifts.push({ it: it, o: o }); }); });
    var pl = slot(v, 'presentes');
    gifts.forEach(function (g) { pl.appendChild(montarItemLinha('presente', g.it, fData(g.o.criadoEm) + ' · ' + g.o.numero)); });
    cond(v, 'sem-presentes', gifts.length === 0);
    if (!gifts.length) setText(v, 'sem-presentes', fmt(T.sem_presentes, { n: p.nome }));

    var fs = st.fatos.filter(function (f) { return f.presenteadoId === p.id; });
    var fl = slot(v, 'fatos');
    fs.forEach(function (f) { fl.appendChild(montarFato(f)); });
    cond(v, 'sem-fatos', fs.length === 0);
    if (!fs.length) setText(v, 'sem-fatos', fmt(T.sem_fatos_pessoa, { n: p.nome }));
    /* T8-6 e T8-12: "Responder de novo" so para quem ja tem resposta das perguntas */
    setText(v, 'quiz-rot', fmt(respondeu(p.id) ? T.quiz_mais : T.quiz_conhecer, { n: p.nome }));
    setContent(v);
  }

  function montarDataRow(d) {
    var r = clone('data-row');
    r.setAttribute('data-id', d.id);
    setText(r, 'dia', String(d.dia).padStart(2, '0'));
    setText(r, 'mes', (MES_CURTO[d.mes - 1] || '').toUpperCase());
    setText(r, 'titulo', d.titulo);
    setText(r, 'quando', fmt(T.quando_proxima, { n: proxLabel(d.dia, d.mes) }));
    /* procedencia: data nascida de um evento ou de uma compra (o dia da compra,
       lembrete do ano seguinte) se explica na propria linha */
    cond(r, 'origem', d.origem === 'evento');
    cond(r, 'origem-compra', d.origem === 'compra');
    var sw = slot(r, 'switch'); sw.setAttribute('aria-checked', d.lembreteAtivo ? 'true' : 'false');
    sw.setAttribute('aria-label', T.lembrete + ' ' + d.titulo);
    return r;
  }
  /* T8-4 (dono, 31/10): o fato fica sempre no bloco da pessoa, entao a linha de
     baixo nao repete o nome (saiu a versao "solo" da lista unica) */
  function montarFato(f) {
    var n = clone('fato');
    n.classList.add(CAT_CLS[f.categoria] || 'mwc-fato-gosto');
    n.setAttribute('data-id', f.id);
    setText(n, 'texto', f.texto);
    /* T5.8 (dono, 29/10): so a origem, sem a categoria (a cor da borda segue a categoria).
       T8-1c: com a memoria ligada, o que veio da conversa diz quem contou e quando (a
       data sem quebra no meio, como na montagem aprovada) */
    var m = ORIG_ROT[f.origem] || '';
    if (st.memLig && f.origem === 'curador') m = T.origem_curador_data + (f.createdAt ? ' · ' + fData(f.createdAt).replace(/ /g, '\u00a0') : '');
    setText(n, 'meta', m.toUpperCase());
    return n;
  }

  /* ---------- Pedidos ---------- */
  function renderPedidos() {
    /* o nome que esta sendo digitado no "+ Nova pessoa" sobrevive ao redesenho que chega da rede */
    var vel = contentEl.querySelector('[data-field="vNovaNome"]'); st.vincTxt = vel ? vel.value : '';
    var v = clone('pedidos');
    cond(v, 'vazio', st.pedidos.length === 0);
    var cont = slot(v, 'pedidos');
    st.pedidos.forEach(function (o) { cont.appendChild(montarPedido(o)); });
    setContent(v);
    if (!st.pedidos.length) iniciarPollPedidos();
  }
  function montarPedido(o) {
    var n = clone('ped-card');
    n.setAttribute('data-id', o.id);
    setText(n, 'numero', o.numero);
    setText(n, 'data', fData(o.criadoEm));
    /* sem eventoNome o slot fica vazio e o :empty do CSS o tira do flex */
    setText(n, 'eventoNome', o.eventoNome && fmt(T.pedido_do_evento, { evento: o.eventoNome }));
    cond(n, 'via-curador', !!o.viaCurador);
    var si = statusInfo(o.statusEntrega);
    var dot = slot(n, 'dot'); if (dot) dot.className = 'mwc-status-dot ' + si.c;
    setText(n, 'status', si.r);
    /* T6-11: o servidor manda variosDestinos e o paraNome de cada item; sem os
       campos (resposta antiga), o pedido fica como era */
    var varios = o.variosDestinos === true, sem = semPessoa(o), aberto = !sem && st.vincAberto === o.id, vid = 'mwc-vinc-' + o.id;
    var itens = slot(n, 'itens');
    o.itens.forEach(function (it) { itens.appendChild(montarItemLinha('item', it, itemLinhaTxt(it), varios && it.paraNome)); });
    /* T6-2 e T6-13: o nome e estado e fica com o painel aberto; os botoes somem
       enquanto ele esta aberto (o "Pronto" fecha) */
    var alvo = !sem && o.presenteadoId ? acharP(o.presenteadoId) : null;
    cond(n, 'tem-vinculo', !!alvo);
    if (alvo) setText(n, 'vinculo-nome', fmt(T.presente_para, { n: alvo.nome }));
    S(cond(n, 'outra', !!alvo && !aberto), 'aria-controls', vid);
    S(cond(n, 'sem-vinculo', !sem && !alvo && !aberto), 'aria-controls', vid);
    var url = slot(n, 'url-oficial'); if (url) url.href = o.urlOficial || HOSTED || '#';
    var vbox = slot(n, 'vincular'); vbox.id = vid;
    if (aberto) { vbox.hidden = false; vbox.appendChild(montarVincular(o, alvo)); } else vbox.hidden = true;
    return n;
  }
  function montarItemLinha(name, it, linha, para) {
    var n = clone(name);
    thumbImg(slot(n, 'thumb'), it.img, it.titulo);
    setText(n, 'titulo', it.titulo);
    setText(n, 'linha', linha);
    cond(n, 'para', !!para); if (para) setText(n, 'para', fmt(T.pra_nome, { n: para }));
    /* tri-estado: null (cache frio do catalogo no backend) nao vira "esgotado" */
    cond(n, 'disponivel', it.disponivel === true); cond(n, 'esgotado', it.disponivel === false);
    if (it.disponivel) { var b = n.querySelector('[data-act="repetir"]'); S(b, 'data-vid', it.variantId); S(b, 'data-titulo', it.titulo); S(b, 'data-handle', it.handle || ''); }
    else if (it.disponivel === false) perguntaCurador(slot(n, 'parecido'), [it]);
    return n;
  }
  /* N1 e N1c (dono, 31/10): o "achar parecido" abre o Curador ja com a pergunta
     pelo vinho que acabou e o handle dele, como o botao da PDP esgotada; o clique
     e do mw-curador.js (nucleo, intocado). Mais de um vinho: a frase cita todos,
     e o contexto leva o primeiro handle. */
  function lista(a) { return LF ? LF.format(a) : a.join(', '); }
  function perguntaCurador(b, its) {
    var h = its.filter(function (it) { return it.handle; })[0];
    S(b, 'data-mw-curador-pergunta', its.length > 1 ? fmt(T.parecido_n, { n: lista(its.map(function (it) { return it.titulo; })) }) : fmt(T.parecido_1, { n: its[0].titulo }));
    if (h) S(b, 'data-mw-curador-produto', h.handle);
    return b;
  }
  /* a acao do aviso: um botao temporario com os mesmos atributos, clicado e removido */
  function parecido(its) { var b = perguntaCurador(mk('button'), its); b.type = 'button'; b.hidden = true; root.appendChild(b); b.click(); b.remove(); }
  function itemLinhaTxt(it) { return it.quantidade + ' ' + T.unidade + ' · ' + fmtBRL(it.preco); }
  function montarVincular(o, alvo) {
    var w = clone('vincular-painel'), nova = st.vincNova === o.id;
    var cp = slot(w, 'chips-pessoas');
    st.presenteados.forEach(function (p) {
      cp.appendChild(montarChip({ rotulo: p.nome, inicial: iniciais(p.nome), sel: o.presenteadoId === p.id, act: 'pick-pessoa', data: { pid: p.id } }));
    });
    /* T6-3: "Ninguem em especial" entre as pessoas, como na janela de data, marcado sem pessoa */
    cp.appendChild(montarChip({ rotulo: T.df_ninguem, sel: !alvo, act: 'pick-pessoa-nenhum' }));
    /* T6-7: o chip some e o campo abre ali; Enter cria, Esc fecha sem criar ninguem */
    if (!nova) cp.appendChild(montarChip({ rotulo: T.nova_pessoa, act: 'novo-pelo-vincular', dash: true }));
    var i = cond(w, 'v-nova', nova).querySelector('input');
    if (nova) {
      i.value = st.vincTxt || '';
      i.onkeydown = function (e) {
        if (e.key === 'Enter') { e.preventDefault(); novaPessoaPedido(o); }
        else if (e.key === 'Escape') { e.preventDefault(); st.vincNova = null; renderView(); focoEm(o.id, '[data-act="novo-pelo-vincular"]'); }
      };
    }
    cond(w, 'tem-alvo', !!alvo);
    if (alvo) {
      /* T6-14 (dono, 01/11): a data que a loja cria na compra nao e ocasiao e fica so
         na ficha; o pedido nela conta como "Nenhuma". A fileira termina sempre em
         "+ Nova ocasiao", que abre a janela com a pessoa (o T6-8 marca a salva). */
      var cd = slot(w, 'chips-datas');
      datasDe(alvo.id).forEach(function (d) {
        if (d.origem !== 'compra') cd.appendChild(montarChip({ rotulo: d.titulo + ' · ' + fDiaMes(d.dia, d.mes), sel: o.dataImportanteId === d.id, act: 'pick-data', data: { did: d.id } }));
      });
      cd.appendChild(montarChip({ rotulo: T.nenhuma, sel: semOcasiao(o), act: 'pick-data-nenhuma' }));
      cd.appendChild(montarChip({ rotulo: T.nova_ocasiao, act: 'add-data-alvo', dash: true }));
      linhaLembrete(slot(w, 'lembrete'), o, alvo);
    }
    return w;
  }
  /* T6-14: sem ocasiao = "Nenhuma": sem data, na data da compra, ou numa data que
     saiu da lista (apagada na ficha, tambem durante o DESFAZER, que a devolve) */
  function semOcasiao(o) { var d = o.dataImportanteId && byId(st.datas, o.dataImportanteId); return !d || d.origem === 'compra'; }
  /* T6-14: a linha do lembrete do presente, so com o campo "lembrete" do servidor (a
     data que manda o email com o vinho; null antes da rotina, e ai a linha nao
     aparece). O dia, o mes, a chave e a origem vem dessa mesma data em st.datas, para
     o que mudou na ficha valer na volta; a data que saiu da lista nao tem linha (os
     pedidos sao relidos depois do DELETE). Uma frase por caso, e o link leva aonde o
     lembrete se muda: a ficha, ou Preferencias quando os lembretes de datas estao
     desligados no email. */
  function linhaLembrete(el, o, alvo) {
    var l = o.lembrete, pf = st.perfil && st.perfil.preferencias, b, x, p, c;
    if (!l || !(x = byId(st.datas, l.dataId))) return;
    el.hidden = false;
    if (pf && pf.emailLembretes === false) {
      el.textContent = T.lembrete_geral_off + ' ';
      b = mk('button', 'mwc-inline-link', T.ver_preferencias); S(b, 'data-act', 'ir'); S(b, 'data-view', 'preferencias');
    } else {
      /* o email com este vinho e o da ocorrencia seguinte a que a compra presenteou. A
         compra presenteia a ocorrencia X quando cai de X - antes ate o fim do dia X + 30,
         com antes = 12 na data da compra e 45 nas outras (JANELA_ANTES_CURTA_DIAS e
         JANELA_ANTES_LONGA_DIAS em painel/src/lib/nudges/lembrete-data.ts, a fonte):
         logo, a primeira a partir de criadoEm + antes + 1 dia, e nunca antes de hoje */
      c = new Date(o.criadoEm);
      p = proxData(x.dia, x.mes, new Date(c.getFullYear(), c.getMonth(), c.getDate() + (x.origem === 'compra' ? 12 : 45) + 1)).data;
      el.textContent = (x.lembreteAtivo ? fmt(T.lembrete_pedido_on, { d: fDiaMes(p.getDate(), p.getMonth() + 1), a: p.getFullYear() }) : T.lembrete_pedido_off) + ' ';
      b = mk('button', 'mwc-inline-link', fmt(T.ver_datas_de, { n: alvo.nome })); S(b, 'data-act', 'abrir-presenteado'); S(b, 'data-id', alvo.id);
    }
    b.type = 'button'; el.appendChild(b);
  }
  function montarChip(o) {
    var c = clone('chip');
    if (o.inicial) { cond(c, 'avatar', true); setText(c, 'inicial', o.inicial); } else cond(c, 'avatar', false);
    setText(c, 'rotulo', o.rotulo);
    cond(c, 'sel', !!o.sel);
    c.setAttribute('aria-pressed', o.sel ? 'true' : 'false');
    c.setAttribute('data-act', o.act);
    if (o.dash) c.classList.add('mwc-chip-dash');
    if (o.data) for (var k in o.data) c.setAttribute('data-' + k, o.data[k]);
    return c;
  }

  /* ---------- Curador ---------- */
  /* T8-1d, T8-3, T8-3b, T8-4 e T8-4b (dono, 31/10): no topo o convite, com um botao
     por pessoa que ainda nao respondeu, na ordem da aba Pessoas (some quando todas
     responderam); embaixo a memoria, um bloco por pessoa de quem o Curador sabe
     algo, com o "Responder de novo" de quem ja respondeu, e "Outros" no fim (o fato
     sem pessoa, ou de pessoa que nao esta mais na lista). Quem so tem a resposta do
     "gostou?" fica no bloco, sem botao, e no convite. Sem ninguem cadastrado, o
     cartao vazio com o botao de cadastro. */
  function renderCurador() {
    var v = clone('curador'), ps = st.presenteados, cb = slot(v, 'convite-botoes'), bl = slot(v, 'blocos');
    var falta = ps.filter(function (p) { return !respondeu(p.id); });
    cond(v, 'convite', falta.length > 0);
    falta.forEach(function (p) { cb.appendChild(botaoQuiz(mk('button', 'mwc-btn mwc-btn-gold'), T.quiz_responder, p)); });
    if (st.memLig) bl.appendChild(blocoVoce());
    ps.forEach(function (p) {
      var fs = st.fatos.filter(function (f) { return f.presenteadoId === p.id; });
      if (!fs.length) return;
      var b = clone('mem-pessoa');
      setText(b, 'inicial', iniciais(p.nome)); setText(b, 'nome', p.nome); setText(b, 'relacao', rel(p));
      fs.forEach(function (f) { slot(b, 'fatos').appendChild(montarFato(f)); });
      if (respondeu(p.id)) botaoQuiz(cond(b, 'de-novo', true), T.quiz_mais, p);
      bl.appendChild(b);
    });
    var outros = st.fatos.filter(function (f) { return (!f.presenteadoId || !acharP(f.presenteadoId)) && !(st.memLig && f.sobreVoce); });
    if (outros.length) {
      var o = clone('mem-outros');
      outros.forEach(function (f) { slot(o, 'fatos').appendChild(montarFato(f)); });
      bl.appendChild(o);
    }
    cond(v, 'memoria', st.memLig || st.fatos.length > 0 || !ps.length);
    cond(v, 'vazia', !ps.length);
    var cl = slot(v, 'conversas');
    st.conversas.forEach(function (c) { cl.appendChild(montarConversa(c)); });
    cond(v, 'conversas-vazia', st.conversas.length === 0);
    setContent(v);
  }
  function botaoQuiz(b, txt, p) { b.type = 'button'; b.textContent = fmt(txt, { n: p.nome }); S(b, 'data-act', 'iniciar-quiz-pessoa'); S(b, 'data-id', p.id); return b; }
  /* T8-1c (dono, 01/11): so com a memoria ligada (memoriaLigada do GET /memoria, a
     chave contextoCuradorEnabled do painel). O bloco "Voce" vem antes das pessoas,
     sempre, no molde do bloco da pessoa, com o circulo do menu da conta (so a
     inicial; a foto fica no cartao de Preferencias). Nele, o nome com "Mudar", os
     pedidos que o Curador usa (os nao cancelados, ate 5) com "Ver pedidos", o que
     o cliente contou na conversa com o X, e o botao que abre o Curador ja com a
     frase (o clique e do mw-curador.js, como o "achar parecido"). */
  function nPed() { return Math.min(5, st.pedidos.filter(function (o) { return !(o.cancelado || o.statusEntrega === 'cancelado'); }).length); }
  function blocoVoce() {
    var b = clone('mem-pessoa'), fl = slot(b, 'fatos'), n = nPed(), c = cond(b, 'de-novo', true);
    b.querySelector('.mwc-avatar').className = 'mwc-avatar mwc-avatar-44';
    setText(b, 'inicial', iniciais(st.nome)); setText(b, 'nome', T.memoria_voce);
    if (st.nome) fl.appendChild(linhaVoce(fmt(T.voce_nome, { n: st.nome }), T.voce_mudar, 'preferencias'));
    if (n) fl.appendChild(linhaVoce(n === 1 ? T.voce_pedidos_one : fmt(T.voce_pedidos_other, { n: n }), T.voce_ver_pedidos, 'pedidos'));
    st.fatos.forEach(function (f) { if (f.sobreVoce) fl.appendChild(montarFato(f)); });
    if (!fl.firstChild) fl.remove();
    c.removeAttribute('data-act'); c.textContent = T.voce_contar; S(c, 'data-mw-curador-pergunta', T.voce_contar_msg);
    return b;
  }
  /* a linha do nome e a dos pedidos: o molde do fato, sem a origem, com o link no lugar do X */
  function linhaVoce(txt, rot, vista) {
    var n = clone('fato'), a = mk('button', 'mwc-inline-link', rot);
    setText(n, 'texto', txt); slot(n, 'meta').remove();
    a.type = 'button'; S(a, 'data-act', 'ir'); S(a, 'data-view', vista);
    n.replaceChild(a, n.querySelector('.mwc-fato-x'));
    return n;
  }
  function montarConversa(c) {
    var n = clone('conversa');
    setText(n, 'trecho', '"' + (c.trecho || '') + '"');
    setText(n, 'data', fData(c.em || c.iniciadaEm));
    var vb = slot(n, 'vinhos');
    /* Contrato: `vinhosInfo` ({handle, nome, url, img, disponivel}) quando o backend
       o manda, `vinhos` (string[]) na resposta antiga. `nome` vem null com o cache
       do catalogo frio, entao o humanizador do handle continua sendo o piso.
       T8-9 (dono, 31/10): com a url (o vinho ainda na loja, /products/<handle>), a
       etiqueta inteira e o link, na mesma aba; sem ela, fica o texto. */
    (c.vinhosInfo || c.vinhos || []).forEach(function (v) {
      var u = v && v.url, a = mk(/^\/[^\/]/.test(u) ? 'a' : 'span', 'mwc-conversa-vinho', (v && v.nome) || nomeDoHandle((v && v.handle) || v));
      if (a.tagName === 'A') a.href = u;
      vb.appendChild(a);
    });
    return n;
  }

  /* ---------- Preferencias ---------- */
  function renderPrefs() {
    var v = clone('prefs');
    var pf = (st.perfil && st.perfil.preferencias) || {};
    val(v, 'nomeExib', st.nome || '');
    Array.prototype.forEach.call(v.querySelectorAll('[data-act="toggle-pref"]'), function (b) {
      b.setAttribute('aria-checked', pf[b.getAttribute('data-chave')] ? 'true' : 'false');
    });
    var hl = slot(v, 'hosted-link'); if (hl) hl.href = HOSTED || '#';
    ligarFoto(v);
    pintarFoto(v);
    setContent(v);
  }

  /* ---------- Foto de perfil (P6) ----------
   * O peso do upload (reduzir a imagem, XHR com progresso, mapa de erro) vive
   * em assets/mw-midia.js, que carrega nesta pagina e na do evento. Aqui fica
   * so a tela. A foto ja vem no GET /perfil do boot (perfil.fotoUrl): nenhuma
   * chamada nova. */
  var fotoEnviando = false, fotoErro = null, fotoCancelada = false;
  function fotoUrl() { return (st.perfil && st.perfil.fotoUrl) || null; }
  function pintarFoto(v) {
    var tem = !!fotoUrl() || fotoEnviando, erro = !!fotoErro && !fotoEnviando;
    cond(v, 'foto-sem', !tem && !erro);
    cond(v, 'foto-tem', tem && !erro);
    cond(v, 'foto-env', fotoEnviando);
    /* a ordem importa: o container do role="alert" sai do hidden ANTES de receber
       o texto, senao o leitor de tela nao anuncia a mudanca */
    cond(v, 'foto-erro', erro);
    if (erro) setText(v, 'foto-motivo', fotoErro);
    var aro = slot(v, 'foto-aro'); if (aro) aro.classList.toggle('mwc-avatar-erro', erro);
    setText(v, 'foto-ini', iniciais(st.nome));
    /* com upload em voo a previa manda na imagem (mesma regra da capa do
       evento): repintura no meio do envio nao pode desfazer a previa */
    var img = slot(v, 'foto-img');
    if (img && !fotoEnviando) { img.hidden = !fotoUrl(); if (fotoUrl()) img.src = fotoUrl(); }
  }
  function fotoProgresso(f) { var p = contentEl && slot(contentEl, 'foto-prog'); if (p) p.value = f; }
  /* previa ANTES da rede: o blob ja reduzido e exatamente o que vai subir */
  function previaFoto(u) {
    var img = contentEl && slot(contentEl, 'foto-img');
    if (img) { img.src = u; img.hidden = false; }
  }
  function fimFoto(msg) {
    fotoEnviando = false; fotoErro = null;
    if (contentEl) pintarFoto(contentEl);
    toast(msg);
  }
  /* R-60: o erro vira ESTADO do card (role="alert"), nao toast. O motivo cita o
     numero real - `tam` e `maxMb` vem do objeto de erro do mw-midia.js - porque
     "arquivo invalido" nao diz a ninguem o que fazer em seguida. */
  function erroFoto(e) {
    fotoEnviando = false;
    var c = (e && e.c) || 'rede';
    fotoErro = fotoCancelada ? null
      : c === 'tamanho' ? fmt(T.foto_e_tam, { tam: (e && e.tam) || '', maxMb: (e && e.maxMb) || 0 })
      : c === 'tipo' ? T.foto_e_tipo
      : c === 'teto' ? T.foto_e_teto
      : T.foto_e_rede;
    fotoCancelada = false;
    if (contentEl) pintarFoto(contentEl); // a previa some: fica o que esta salvo
  }
  function ligarFoto(v) {
    var arq = v.querySelector('[data-field="fotoArq"]');
    var M = window.MWMidia;
    if (!arq || !M) return;
    M.ligar(arq, {
      url: API + '/perfil/foto',
      lado: 512,
      antes: function () { fotoEnviando = true; fotoErro = null; fotoCancelada = false; fotoProgresso(0); if (contentEl) pintarFoto(contentEl); },
      previa: previaFoto,
      andamento: fotoProgresso,
      /* Cancelar so tem efeito enquanto a resposta nao chegou; se ela chegar
         depois, o servidor JA trocou a foto e a unica forma de honrar o cancelamento
         e desfazer com o DELETE. Cancelamento exato dependeria de o mw-midia.js
         expor o abort() do XHR, o que ele nao faz hoje. */
      ok: function (j) {
        if (fotoCancelada) { fotoCancelada = false; req('DELETE', '/perfil/foto').catch(function () {}); return; }
        if (st.perfil) st.perfil.fotoUrl = j.fotoUrl || null;
        fimFoto(T.foto_ok);
      },
      erro: erroFoto
    });
  }
  function escolherFoto() {
    var arq = contentEl && contentEl.querySelector('[data-field="fotoArq"]');
    if (arq) arq.click();
  }
  function cancelarFoto() {
    if (!fotoEnviando) return;
    fotoCancelada = true; fotoEnviando = false; fotoErro = null;
    if (contentEl) pintarFoto(contentEl);
  }
  /* R-60: remover e destrutivo, entao e reversivel - mesmo molde do removerComUndo
     (some da tela na hora, DELETE so quando o toast expira, e o pagehide fecha o
     que ficou pendente). */
  function removerFoto() {
    var antes = fotoUrl();
    if (!antes) return;
    if (st.perfil) st.perfil.fotoUrl = null;
    fotoErro = null;
    if (contentEl) pintarFoto(contentEl);
    pendentes.foto = { path: '/perfil/foto' };
    toast(T.foto_removida, {
      acaoRot: T.acao_desfazer,
      acao: function () {
        delete pendentes.foto;
        if (st.perfil) st.perfil.fotoUrl = antes;
        if (contentEl) pintarFoto(contentEl);
      },
      onExpire: function () { delete pendentes.foto; req('DELETE', '/perfil/foto').then(sessaoCaiu, function () {}); }
    });
  }

  /* ---------- toggles (J39: processando + reverte em falha; um so motor) ---------- */
  function setSwitch(b, on) { S(b, 'aria-checked', on ? 'true' : 'false'); }
  function pick(k, v) { var o = {}; o[k] = v; return o; }
  function toggle(b, faz, ok) {
    if (b.hasAttribute('data-processando')) return;
    var novo = G(b, 'aria-checked') !== 'true';
    setSwitch(b, novo); S(b, 'data-processando', '');
    faz(novo).then(function (r) { b.removeAttribute('data-processando'); if (!r || !r._ok) throw r; ok(novo, r); })
      .catch(function (r) { setSwitch(b, !novo); b.removeAttribute('data-processando'); avisoFalha(r, function () { toggle(b, faz, ok); }); });
  }
  function togglePref(b) {
    var chave = G(b, 'data-chave'), pf = st.perfil.preferencias;
    toggle(b, function (novo) { return req('PUT', '/perfil', { preferencias: pick(chave, novo) }); }, function (novo) {
      pf[chave] = novo;
      if (chave === 'emailLembretes' && !novo) {
        var ativos = st.datas.filter(function (d) { return d.lembreteAtivo; }).length;
        if (ativos) return toast(ativos === 1 ? T.toast_pausa_1 : fmt(T.toast_pausa_n, { n: ativos }));
      }
      toast(T.toast_pref_salva);
    });
  }
  function toggleLembrete(b, id) {
    var d = byId(st.datas, id); if (!d) return;
    toggle(b, function (novo) { return req('PUT', '/datas/' + id, { lembreteAtivo: novo }); }, function (novo, r) {
      d.lembreteAtivo = novo;
      var pf = st.perfil && st.perfil.preferencias;
      if (novo && pf && !pf.emailLembretes) { pf.emailLembretes = true; toast(T.toast_acender_toggle, { acaoRot: T.acao_ajustar, acao: function () { irVista('preferencias'); } }); } // J16 backend acende; J39 AJUSTAR
      else toast(novo ? T.toast_lembrete_on : T.toast_lembrete_off);
      depoisDoPutData(id, r, b); // T6-14: a ocasiao ligada pode absorver a data da compra
    });
  }

  /* ---------- vinculo pedido -> pessoa/data ---------- */
  /* Grava a pessoa (p) e a ocasiao (d) do pedido; ap/ad sao as de antes. A tela
     muda antes da resposta, e a falha devolve o que estava (so se nada mudou desde
     entao). T6-12 (dono, 31/10): a pessoa ou a data apagada em outro aparelho (404
     pessoa_nao_encontrada / data_nao_encontrada) sai da lista na hora, com um aviso
     sem botao, porque tentar de novo falharia igual, e as listas sao relidas em
     segundo plano. O resto (rede, 5xx, o 409 vinculo_mudou, o 404 nao_encontrado de
     antes) tem TENTAR DE NOVO, que grava de novo o mesmo.
     Lembrete do ano seguinte (lancamento, 2026-10-26): o servidor pode mover a data de
     compra junto com a pessoa do pedido (ou criar uma data nova para ela) e devolve a
     data que ficou; o pedido grava essa data e as datas sao relidas, para o proximo
     salvar do formulario nao mandar um estado velho. T6-14 (dono, 01/11): a resposta
     traz tambem o lembrete do pedido, como ficou, e as datas criadas e tiradas;
     rp: rele os pedidos mesmo sem elas (a ocasiao salva pelo painel, T6-8).
     O pedido e buscado pelo id a cada passo (ag): a releitura troca st.pedidos por
     objetos novos, e mudar o de antes nao chegaria a tela. */
  var gesto = 0, voo = 0, relerDepois = 0;
  function gravarVinculo(o, p, d, ap, ad, rp) {
    var id = o.id, ag = function () { return (o = byId(st.pedidos, id) || o); };
    ag().presenteadoId = p; o.dataImportanteId = d; renderView();
    var igual = function () { ag(); return o.presenteadoId === p && o.dataImportanteId === d; };
    var falha = function (r) {
      var e = r && r.erro, pe = e === 'pessoa_nao_encontrada', de = e === 'data_nao_encontrada', quem = acharP(p);
      if (igual()) { o.presenteadoId = ap; o.dataImportanteId = ad; }
      if (pe) st.presenteados = st.presenteados.filter(function (x) { return x.id !== p; });
      if (de) st.datas = st.datas.filter(function (x) { return x.id !== d; });
      renderView();
      if (pe || de) { toast(pe ? fmt(T.erro_pessoa_sumiu, { n: quem ? quem.nome : '' }) : T.erro_data_sumiu, { erro: true }); reler(); }
      else avisoFalha(r, function () { gravarVinculo(o, p, d, ap, ad, rp); });
      if (relerDepois) relerPedidos();
    };
    gesto++; voo++;
    req('PUT', '/pedidos/' + id + '/presenteado', { presenteadoId: p, dataImportanteId: d }).then(function (r) {
      voo--;
      if (!r || !r._ok) return falha(r);
      if (igual()) { if ('data' in r) o.dataImportanteId = r.data ? r.data.id : null; if ('lembrete' in r) o.lembrete = r.lembrete; }
      if (!novasDatas(r) && (rp || relerDepois)) relerPedidos();
      return req('GET', '/datas').then(function (j) { if (j && j._ok && j.datas) st.datas = semApagadas(j.datas); renderView(); });
    }, function (r) { voo--; falha(r); }).catch(function () {});
  }
  /* T6-14: as datas que a rota criou (a data da compra que volta) e as que tirou (a
     que a ocasiao absorveu) entram em st.datas na hora, e os pedidos sao relidos,
     porque o lembrete de algum deles mudou de data. espera: so st.datas, e quem
     chamou rele depois. O redesenho poupa o formulario aberto e as Preferencias. */
  function novasDatas(r, espera) {
    var cr = (r && r.datasCriadas) || [], rm = (r && r.datasRemovidas) || [];
    if (!cr.length && !rm.length) return 0;
    st.datas = semApagadas(st.datas.filter(function (x) { return rm.indexOf(x.id) < 0 && !byId(cr, x.id); }).concat(cr));
    redesenhar();
    if (!espera) relerPedidos();
    return 1;
  }
  /* T6-14: o PUT /datas/:id responde so { ok, datasRemovidas[, datasCriadas] }, sem a
     origem nova (a data da compra com o dia, o mes ou a chave mudados vira "ajustada",
     origemDepoisDaEdicao na rota datas/[id]), que decide a janela da linha do lembrete
     e a fileira de ocasioes: as datas sao relidas, e os pedidos que usam a data tambem,
     se o novasDatas ainda nao os releu. sw: a chave tocada, que fica com o foco depois
     do redesenho. Vem depois do aviso, que efetiva antes o apagar pendente. */
  function depoisDoPutData(id, r, sw) {
    var foco = sw && document.activeElement === sw;
    var usa = st.pedidos.some(function (o) { return o.dataImportanteId === id || (o.lembrete && o.lembrete.dataId === id); });
    if (!novasDatas(r) && usa) relerPedidos();
    req('GET', '/datas').then(function (j) {
      if (!j || !j._ok || !j.datas) return;
      st.datas = semApagadas(j.datas); redesenhar();
      var a = document.activeElement, n = foco && contentEl && (!a || a === document.body || a === sw) && contentEl.querySelector('[data-id="' + id + '"] [data-act="toggle-lembrete"]');
      if (n) n.focus({ preventScroll: true });
    }, function () {});
  }
  /* T6-14: a releitura que saiu antes de um toque no painel do pedido traria o estado
     de antes dele: com um PUT do pedido em voo, ela fica para quando o ultimo voltar,
     e a que volta depois de um toque novo e descartada e refeita */
  function relerPedidos() {
    if (voo) { relerDepois = 1; return; }
    relerDepois = 0;
    var g = gesto;
    req('GET', '/pedidos').then(function (j) {
      if (g !== gesto) return relerPedidos();
      if (j._ok && j.pedidos) { st.pedidos = j.pedidos.map(normalizarPedido); redesenhar(); }
    }, function () {});
  }
  function redesenhar() { if (!st.form && st.view !== 'preferencias') renderView(); }
  /* releitura calada: a lista ja foi corrigida no lugar; o painel aberto continua aberto */
  function reler() {
    Promise.all([req('GET', '/presenteados'), req('GET', '/datas'), req('GET', '/pedidos')]).then(function (r) {
      if (r[0]._ok && r[0].presenteados) st.presenteados = r[0].presenteados.filter(function (x) { return !pendentes['presenteado:' + x.id] && !apagadas['presenteado:' + x.id]; });
      if (r[1]._ok && r[1].datas) st.datas = semApagadas(r[1].datas);
      if (r[2]._ok && r[2].pedidos) st.pedidos = r[2].pedidos.map(normalizarPedido);
      renderView();
    }).catch(function () {});
  }
  /* T6-3b e T6-6 (dono, 31/10): DESFAZER ao tirar a pessoa e ao trocar a pessoa de
     um presente com ocasiao marcada pelo cliente. A data de compra muda de pessoa
     junto com o pedido no servidor, e um PUT nao a devolveria: ai o aviso fica sem
     botao, e tocar de novo na pessoa de antes a devolve pela mesma regra. */
  function avisoTroca(o, pid, ap, ad) {
    var p = pid && acharP(pid), da = ad && byId(st.datas, ad), dc = da && da.origem === 'compra';
    toast(p ? fmt(T.toast_vinculo_pra, { n: p.nome }) : T.toast_sem_pessoa, !pid || (da && !dc) ? {
      acaoRot: T.acao_desfazer,
      /* o DESFAZER manda a data de antes, tambem a da compra: o servidor trata a pessoa
         com a mesma data da compra como a troca de pessoa (e). T6-14: o pedido e o de
         st.pedidos agora, que uma releitura pode ter trocado */
      acao: function () { var c = byId(st.pedidos, o.id) || o; gravarVinculo(c, ap, ad, c.presenteadoId || null, c.dataImportanteId || null); }
    } : {});
  }
  /* tocar no que ja esta marcado nao faz nada; o chip de pessoa ou de data ainda
     sem id do servidor (tmp_) tambem nao grava */
  function setVinculoPessoa(pedidoId, pid) {
    var o = byId(st.pedidos, pedidoId), ap = o && (o.presenteadoId || null);
    if (!o || ap === pid || /^tmp_/.test(pid)) return;
    var ad = o.dataImportanteId || null;
    gravarVinculo(o, pid, null, ap, ad);
    avisoTroca(o, pid, ap, ad);
  }
  /* mudo: a data cadastrada pelo painel (T6-8) fica so com o "Data salva.", e os
     pedidos sao relidos depois. T6-14: o pedido sem ocasiao (semOcasiao) ja esta em
     "Nenhuma", e o toque nela nao grava nada. */
  function setVinculoData(pedidoId, did, mudo) {
    var o = byId(st.pedidos, pedidoId), ad = o && (o.dataImportanteId || null);
    if (!o || ad === did || /^tmp_/.test(did) || (!did && semOcasiao(o))) return;
    gravarVinculo(o, o.presenteadoId || null, did, o.presenteadoId || null, ad, mudo);
    if (!mudo) toast(did ? T.toast_vinculo_data : T.toast_sem_data);
  }
  /* T6-7 (dono, 31/10): a pessoa nasce no painel do pedido ja marcada; o pedido so
     e gravado com o id do servidor (nunca o tmp_), e a falha tira o chip */
  function novaPessoaPedido(o) {
    fieldErro(contentEl, 'vNovaNome', '');
    var nome = readF(contentEl, 'vNovaNome');
    if (!o || !nome) return fieldErro(contentEl, 'vNovaNome', T.val_nome);
    var tmp = { id: 'tmp_' + Date.now(), nome: nome }, t = tmp.id, ap = o.presenteadoId || null, ad = o.dataImportanteId || null;
    st.presenteados.push(tmp); st.vincNova = null;
    o.presenteadoId = t; o.dataImportanteId = null; renderView();
    focoEm(o.id, '[data-pid="' + t + '"]');
    avisoTroca(o, t, ap, ad);
    persistir(function () { return req('POST', '/presenteados', { nome: nome }); }, function () {
      st.presenteados = st.presenteados.filter(function (x) { return x !== tmp; });
      if (o.presenteadoId === t) { o.presenteadoId = ap; o.dataImportanteId = ad; }
      renderView();
    }).then(function (r) {
      if (!r || !r.id) return;
      tmp.id = r.id;
      var ch = contentEl.querySelector('[data-pid="' + t + '"]'); if (ch) S(ch, 'data-pid', r.id);
      if (o.presenteadoId === t) gravarVinculo(o, r.id, null, ap, ad);
    }, function () {});
  }
  function fecharNova() { if (st.vincNova) { st.vincNova = null; renderView(); } }

  /* ---------- remover com undo (J10 commit adiado / J35) ---------- */
  /* toda releitura de /datas tira o que o cliente apagou: a data e as da pessoa com o
     apagar no DESFAZER (pendentes) ou com o DELETE ja enviado (apagadas), que o
     servidor pode atender depois do GET */
  function semApagadas(ds) {
    var fora = function (k) { return pendentes[k] || apagadas[k]; };
    return ds.filter(function (x) { return !fora('data:' + x.id) && !fora('presenteado:' + x.presenteadoId); });
  }
  function removerComUndo(tipo, id, msg) {
    var lista = function () { return tipo === 'presenteado' ? st.presenteados : tipo === 'data' ? st.datas : st.fatos; };
    var arr = lista(), falta = function (a, b) { return b.filter(function (x) { return !byId(a, x.id); }); };
    var idx = -1; for (var i = 0; i < arr.length; i++) if (arr[i].id === id) { idx = i; break; }
    if (idx < 0) return;
    var item = arr[idx]; arr.splice(idx, 1);
    var extras = null;
    if (tipo === 'presenteado') {
      extras = { datas: st.datas.filter(function (d) { return d.presenteadoId === id; }), fatos: st.fatos.filter(function (f) { return f.presenteadoId === id; }) };
      st.datas = st.datas.filter(function (d) { return d.presenteadoId !== id; });
      st.fatos = st.fatos.filter(function (f) { return f.presenteadoId !== id; });
      st.vincAberto = null; if (st.dossieId === id) { irVista('presenteados'); } else renderView();
    } else renderView();
    var path = tipo === 'fato' ? '/memoria/' + id : '/' + (tipo === 'presenteado' ? 'presenteados' : 'datas') + '/' + id;
    var key = tipo + ':' + id;
    if (String(id).indexOf('tmp_') !== 0) pendentes[key] = { path: path };
    toast(msg, {
      acaoRot: T.acao_desfazer,
      acao: function () {
        delete pendentes[key];
        /* na lista de agora (a releitura troca st.datas), so o que falta nela */
        arr = lista(); if (!byId(arr, id)) arr.splice(idx, 0, item);
        if (extras) { st.datas = st.datas.concat(falta(st.datas, extras.datas)); st.fatos = st.fatos.concat(falta(st.fatos, extras.fatos)); }
        renderView();
        /* a pessoa que volta: as datas dela que nasceram enquanto ela estava pendente
           (datasCriadas filtradas) chegam pela releitura */
        if (extras) req('GET', '/datas').then(function (j) { if (j && j._ok && j.datas) { st.datas = semApagadas(j.datas); redesenhar(); } });
      },
      onExpire: function () {
        delete pendentes[key];
        /* T6-14: os pedidos da ocasiao apagada voltam para a data da compra (datasCriadas);
           sem elas, o pedido que usava a data apagada (a da compra, pelo link do pedido)
           tem o lembrete relido */
        if (String(id).indexOf('tmp_') !== 0) {
          apagadas[key] = 1;
          req('DELETE', path).then(function (r) {
            if (!r._ok) delete apagadas[key];
            sessaoCaiu(r);
            if (!novasDatas(r) && r._ok && tipo === 'data' && st.pedidos.some(function (o) { return o.dataImportanteId === id || (o.lembrete && o.lembrete.dataId === id); })) relerPedidos();
          }, function () { delete apagadas[key]; });
        }
      }
    });
  }
  window.addEventListener('pagehide', function () {
    Object.keys(pendentes).forEach(function (k) {
      try { fetch(API + pendentes[k].path, { method: 'DELETE', keepalive: true }); } catch (e) {}
    });
  });

  /* ---------- repetir presente (J21) ---------- */
  /* T10.5 (dono, 29/10: "Uma mesma mensagem, especialmente as de erro, nao pode
     servir para varios casos diferentes"): um aviso por caso, os mesmos da loja
     ao adicionar (o 'fim' contra 'esg' do falha() de assets/mw-cart.js).
     Recusado (o 422 de estoque e o 404 da variante que saiu do catalogo, como no
     repetirPedido abaixo) = o /cart.js e lido: o vinho ja no carrinho e "todas as
     garrafas ja estao no carrinho" com VER; fora dele, "acabou de esgotar" com o
     "achar parecido" do Curador. Qualquer outra falha, ou a leitura que falha, =
     o aviso de adicionar da loja com TENTAR DE NOVO, que chama este repetir. */
  function lerCarrinho() { return fetch('/cart.js').then(function (x) { if (!x.ok) throw x; return x.json(); }); }
  var repVoo = {};
  function repetir(vid, titulo, handle) {
    if (!window.MWCart || repVoo[vid]) return; // toque duplo (ou o TENTAR DE NOVO durante o add) somaria garrafa
    repVoo[vid] = 1;
    var livre = function () { delete repVoo[vid]; };
    var erro = function () { toast(T.aviso_erro, { erro: true, acaoRot: T.acao_tentar, acao: function () { repetir(vid, titulo, handle); } }); };
    window.MWCart.addVariant(Number(vid)).then(function () {
      livre();
      toast(fmt(T.toast_carrinho, { n: titulo }), { acaoRot: T.acao_ver, acao: abrirCarrinho });
    }, function (e) {
      livre();
      if (!e || (e.status !== 422 && e.status !== 404)) return erro();
      lerCarrinho().then(function (c) {
        if (c.items.some(function (l) { return l.variant_id == vid; })) toast(fmt(T.aviso_no_carrinho, { n: titulo }), { acaoRot: T.acao_ver, acao: abrirCarrinho });
        else toast(fmt(T.aviso_esgotou, { n: titulo }), { erro: true, acaoRot: T.achar_parecido, acao: function () { parecido([{ titulo: titulo, handle: handle }]); } });
      }, erro);
    });
  }
  /* P7 (lancamento): o aviso dizia "De volta no carrinho." mesmo com vinho
     recusado. Um add por vinho; so o disponivel === false fica sem tentar (o
     null, cache frio, e tentado e o add decide). Resultado por vinho: 1 entrou,
     0 recusado pela loja (o 422 de estoque e o 404 da variante que saiu do
     catalogo), 2 qualquer outra falha (rede, 5xx, sem status: o addVariant
     rejeita com a Response ou com o erro de rede). Com algum 0 ou 2, o
     /cart.js e lido UMA vez, como o 'fim' contra 'esg' do mw-cart.js: o
     recusado que ja esta no carrinho (no teto) e o add cuja resposta se perdeu
     mas entrou contam como voltou; sem a leitura, fica como esta. "Acabou" = o
     0 que nao esta no carrinho e o que nem foi tentado. Algum 2 = o aviso de
     adicionar da loja (mw.aviso.erro, "Tente de novo") com VER, e o resultado
     fica em repFalha: o toque seguinte no mesmo pedido tenta so o que nao
     entrou, entao o "tente de novo" nunca soma garrafas aos que ja entraram.
     Esse toque rele o carrinho antes: o vinho que entrou e saiu depois (pelo
     VER) volta a fila; sem a leitura, vale o guardado. O add cuja resposta se
     perdeu e entrou ressincroniza o cabecalho (o addVariant nao contou ele).
     Tudo entrou = o aviso de sempre; parte = os nomes de fora ("A e B"; 3 ou
     mais = "A e mais N"); nada = erro com o "achar parecido" do Curador. O
     botao fica travado (data-processando) enquanto os adds estao em voo: o
     toque duplo somaria garrafas. */
  var LF = null; try { LF = new Intl.ListFormat('pt-BR'); } catch (e) {}
  var repFalha = {};
  function repetirPedido(id, b) {
    var o = byId(st.pedidos, id); if (!o || !window.MWCart || b.hasAttribute('data-processando')) return;
    var ant = repFalha[id], ler = lerCarrinho,
      noCarr = function (c, it) { return c.items.some(function (l) { return l.variant_id == it.variantId; }); };
    delete repFalha[id];
    S(b, 'data-processando', '');
    (ant ? ler().catch(function () { return null; }) : Promise.resolve(null)).then(function (c0) {
      return Promise.all(o.itens.map(function (it, i) {
        if (ant && ant[i] === 1 && (!c0 || noCarr(c0, it))) return 1;
        return it.disponivel !== false && window.MWCart.addVariant(Number(it.variantId)).then(function () { return 1; }, function (e) { return e && (e.status === 422 || e.status === 404) ? 0 : 2; });
      }));
    }).then(function (r) {
      return r.indexOf(0) < 0 && r.indexOf(2) < 0 ? r : ler().then(function (c) {
        var s = r.map(function (v, i) { return (v === 0 || v === 2) && noCarr(c, o.itens[i]) ? 1 : v; });
        if (r.some(function (v, i) { return v === 2 && s[i] === 1; })) window.MWCart.sincronizar().catch(function () {});
        return s;
      }).catch(function () { return r; });
    }).then(function (r) {
      b.removeAttribute('data-processando');
      if (r.indexOf(2) > -1) { repFalha[id] = r; return toast(T.aviso_erro, { erro: true, acaoRot: T.acao_ver, acao: abrirCarrinho }); }
      /* N1d (dono, 31/10): o aviso de um vinho so diz qual acabou, com o texto do
         REPETIR de um vinho; N1c: a acao pergunta ao Curador por todos os que acabaram */
      var foraIt = o.itens.filter(function (it, i) { return !r[i]; }), fora = foraIt.map(function (it) { return it.titulo; }), n = fora.length, m = n > 1;
      if (n === r.length) return toast(m ? T.rep_nada_n : fmt(T.aviso_esgotou, { n: fora[0] }), { erro: true, acaoRot: T.achar_parecido, acao: function () { parecido(foraIt); } });
      if (n > 2) fora = [fora[0], fmt(T.rep_mais, { c: n - 1 })];
      toast(n ? fmt(m ? T.rep_fora_n : T.rep_fora_1, { n: LF ? LF.format(fora) : fora.join(', ') }) : T.toast_carrinho_multi, { acaoRot: T.acao_ver, acao: abrirCarrinho });
    });
  }
  function abrirCarrinho() { if (window.MW) window.MW.abrir('cart'); }
  function abrirCurador() { if (window.MW) window.MW.abrir('curador'); }

  /* ---------- overlays (modal de data / quiz) ---------- */
  /* fechar: o fechamento proprio da janela, que o Esc tambem usa (o do quiz, T8-10) */
  function abrirOverlay(node, nome, fechar) {
    fecharOverlay();
    root.appendChild(node);
    st.overlay = nome; st.oel = node; st.focoAnterior = document.activeElement;
    document.documentElement.classList.add('mw-travado');
    var caixa = node.querySelector('.mwc-modal-caixa');
    var f = focaveis(caixa); (f[0] || caixa).focus();
    node._trap = function (e) {
      if (e.key === 'Escape') { e.preventDefault(); (fechar || fecharOverlay)(); return; }
      if (e.key !== 'Tab') return;
      var fs = focaveis(caixa); if (!fs.length) return;
      var pr = fs[0], ul = fs[fs.length - 1];
      if (e.shiftKey && document.activeElement === pr) { e.preventDefault(); ul.focus(); }
      else if (!e.shiftKey && document.activeElement === ul) { e.preventDefault(); pr.focus(); }
    };
    document.addEventListener('keydown', node._trap);
  }
  function fecharOverlay() {
    if (!st.oel) return;
    document.removeEventListener('keydown', st.oel._trap);
    st.oel.remove(); st.oel = null; st.overlay = null;
    document.documentElement.classList.remove('mw-travado');
    if (st.focoAnterior && st.focoAnterior.focus) st.focoAnterior.focus();
  }
  function focaveis(el) {
    return Array.prototype.slice.call(el.querySelectorAll('a[href],button:not([disabled]),input,textarea,select,[tabindex]:not([tabindex="-1"])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }

  /* ---------- modal de data ---------- */
  /* T7-1f (dono, 31/10): a data nova abre sem ocasiao marcada. Na edicao, a
     'comemorativa' das datas de evento marca a "Outra" (T7-9), e o tipo gravado
     so muda se outro chip for tocado: salvar sem tocar manda o tipo de antes. */
  function abrirDataModal(opts) {
    opts = opts || {};
    var edit = opts.editId ? byId(st.datas, opts.editId) : null;
    st.modal = { editId: opts.editId || null, tipo: edit ? edit.tipo || null : null, vinculo: edit ? edit.presenteadoId : (opts.pid || null), lembrete: edit ? !!edit.lembreteAtivo : true, pedidoId: opts.pedidoId || null, nomeAuto: '', dm: '' };
    var m = clone('modal-data');
    setText(m, 'titulo', edit ? T.data_editar : T.data_nova);
    if (edit) { setF(m, 'dfTitulo', edit.titulo || ''); setF(m, 'dfDia', edit.dia || ''); setF(m, 'dfMes', edit.mes || ''); cond(m, 'df-titulo', true); }
    // chips de vinculo
    var cv = slot(m, 'df-vinculo');
    st.presenteados.forEach(function (p) { cv.appendChild(montarChip({ rotulo: p.nome, inicial: iniciais(p.nome), sel: st.modal.vinculo === p.id, act: 'df-vinculo', data: { pid: p.id } })); });
    cv.appendChild(montarChip({ rotulo: T.df_ninguem, sel: !st.modal.vinculo, act: 'df-vinculo-nenhum' }));
    cv.appendChild(montarChip({ rotulo: T.nova_pessoa, act: 'df-nova-pessoa', dash: true }));
    marcarTipos(m); marcarLembrete(m);
    /* o nome que a janela escreveria para a data gravada: igual a ele, o campo acompanha as trocas */
    if (edit) st.modal.nomeAuto = nomeMontado(m);
    /* T7-6: a data gravada que nao existe (um 31/04 antigo) abre com o 31 a vista e o aviso, sem mover o foco */
    if (edit) fieldErro(m, 'dfDia', st.modal.dm = erroDiaMes(m), 1);
    m.querySelector('[data-mwc-tipos]').onkeydown = setaTipo;
    m.querySelector('[data-field="dfMes"]').onchange = m.querySelector('[data-field="dfDia"]').onblur = conferirDiaMes;
    abrirOverlay(m, 'data');
  }
  /* T7-6: o aviso do dia que o mes nao tem; vazio quando combinam ou quando falta o dia ou o mes */
  function erroDiaMes(scope) {
    var dt = readF(scope, 'dfDia'), dia = +dt, mes = +readF(scope, 'dfMes');
    return /^\d{1,2}$/.test(dt) && dia >= 1 && dia <= 31 && mes >= 1 && dia > diasNoMes(mes) ? fmt(T.val_data_dia_mes, { m: MES_LONGO[mes - 1], n: dia }) : '';
  }
  /* T7-6: na troca do Mes e na saida do Dia, o aviso aparece embaixo do Dia sem
     mover o foco e a regiao viva o anuncia (WCAG 4.1.3); some quando dia e mes
     voltam a combinar. st.modal.dm e o aviso desse tipo que esta na tela: o mesmo
     aviso nao e anunciado de novo, e o erro de outro tipo (o do salvar) fica. */
  function conferirDiaMes() {
    if (!st.oel) return;
    var m = st.modal, msg = erroDiaMes(st.oel);
    if (msg === m.dm) return;
    m.dm = msg; fieldErro(st.oel, 'dfDia', msg, 1); slot(st.oel, 'df-viva').textContent = msg;
  }
  function tipoVis(t) { return t === 'comemorativa' ? 'outra' : t; }
  /* um grupo de escolha unica: um so ponto de tabulacao (o marcado, ou o primeiro) */
  function marcarTipos(scope) {
    var bs = (scope || st.oel).querySelectorAll('[data-act="df-tipo"]'), vis = tipoVis(st.modal.tipo), algum = 0;
    Array.prototype.forEach.call(bs, function (b) {
      var on = G(b, 'data-tipo') === vis; S(b, 'aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1; if (on) algum = 1;
    });
    if (!algum) bs[0].tabIndex = 0;
  }
  /* as setas andam e marcam, como num grupo de radio; o foco fica no chip */
  function setaTipo(e) {
    var k = e.key, p = k === 'ArrowRight' || k === 'ArrowDown' ? 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 0;
    var bs = [].slice.call(this.querySelectorAll('[data-act="df-tipo"]')), i = bs.indexOf(document.activeElement);
    if (!p || i < 0) return;
    e.preventDefault();
    var b = bs[(i + p + bs.length) % bs.length]; escolherTipo(b); b.focus();
  }
  /* T7-1e e T7-3: o primeiro toque mostra o campo, que nao some mais; o toque na
     "Outra" leva o foco ao campo, os outros deixam o foco no chip */
  function escolherTipo(b, toque) {
    var t = G(b, 'data-tipo'), i = cond(st.oel, 'df-titulo', true).querySelector('input');
    if (tipoVis(st.modal.tipo) !== t) st.modal.tipo = t;
    ovErro('dfTipo', ''); marcarTipos(); atualizarNome();
    if (toque && t === 'outra') i.focus();
  }
  /* T7-3: "%o de %n" com o rotulo do chip e a pessoa marcada; sem pessoa, so o
     rotulo; na "Outra", vazio. Cortado no limite do servidor (80). */
  function nomeMontado(scope) {
    var m = st.modal, t = tipoVis(m.tipo), c = t && t !== 'outra' && scope.querySelector('[data-act="df-tipo"][data-tipo="' + t + '"]'), p = m.vinculo && acharP(m.vinculo);
    if (!c) return '';
    var o = c.textContent.trim();
    return (p ? fmt(T.df_titulo_molde, { o: o, n: p.nome }) : o).slice(0, 80);
  }
  /* o campo recebe o nome novo so se estiver vazio ou com o ultimo nome que a
     janela escreveu: o texto que a pessoa escreveu fica */
  function atualizarNome() {
    var m = st.modal, i = st.oel && st.oel.querySelector('[data-field="dfTitulo"]');
    if (!i || !m.tipo) return;
    var v = i.value.trim();
    if (v && v !== m.nomeAuto) return;
    i.value = m.nomeAuto = nomeMontado(st.oel);
  }
  function marcarLembrete(scope) { var b = (scope || st.oel).querySelector('[data-act="df-lembrete"]'); if (b) b.setAttribute('aria-checked', st.modal.lembrete ? 'true' : 'false'); }
  function marcarVinculo() {
    Array.prototype.forEach.call(st.oel.querySelectorAll('.mwc-chip'), function (b) {
      var act = b.getAttribute('data-act'); if (act !== 'df-vinculo' && act !== 'df-vinculo-nenhum') return;
      var on = act === 'df-vinculo-nenhum' ? !st.modal.vinculo : st.modal.vinculo === b.getAttribute('data-pid');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      cond(b, 'sel', on);
    });
  }
  /* C8 (dono, 27/10): a pessoa nova nasce ali mesmo e ja fica marcada; a data espera o
     POST dela para salvar com o id de verdade (nunca o tmp_). */
  function abrirNovaPessoaData(b) {
    b.hidden = true;
    var i = cond(st.oel, 'df-nova', true).querySelector('input');
    i.onkeydown = function (e) { if (e.key === 'Enter') { e.preventDefault(); criarPessoaDaData(); } };
    i.focus();
  }
  function criarPessoaDaData() {
    ovErro('dfNovaNome', '');
    var nome = ov('dfNovaNome');
    if (!nome) { ovErro('dfNovaNome', T.val_nome); return; }
    var tmp = { id: 'tmp_' + Date.now(), nome: nome }, m = st.modal, cv = slot(st.oel, 'df-vinculo');
    var chip = montarChip({ rotulo: nome, inicial: iniciais(nome), sel: true, act: 'df-vinculo', data: { pid: tmp.id } });
    st.presenteados.push(tmp); m.vinculo = tmp.id;
    cv.insertBefore(chip, cv.querySelector('[data-act="df-vinculo-nenhum"]'));
    setF(st.oel, 'dfNovaNome', ''); cond(st.oel, 'df-nova', false);
    cv.querySelector('[data-act="df-nova-pessoa"]').hidden = false;
    marcarVinculo(); atualizarNome(); chip.focus({ preventScroll: true }); chip.scrollIntoView({ block: 'center' }); // o aviso de baixo nao cobre o chip
    toast(fmt(T.toast_novo_presenteado, { n: nome }));
    /* resolve true ou false (nunca rejeita): na falha a janela fica aberta, com o aviso de erro,
       e o nome escrito pelo toque deixa de citar a pessoa que nao nasceu; na sessao vencida
       (401 nao_logado) a janela fecha e fica so o aviso de entrar de novo (avisoFalha, H3) */
    var eu = m.criando = persistir(function () { return req('POST', '/presenteados', { nome: nome }); }, function () {
      st.presenteados = st.presenteados.filter(function (x) { return x !== tmp; });
      if (m.vinculo === tmp.id) m.vinculo = null;
      chip.remove(); if (st.oel && st.modal === m) { marcarVinculo(); atualizarNome(); }
    }).then(function (r) {
      if (r && r.id) { if (m.vinculo === tmp.id) m.vinculo = r.id; tmp.id = r.id; S(chip, 'data-pid', r.id); }
      if (m.criando === eu) m.criando = null;
      return true;
    }, function () { if (m.criando === eu) m.criando = null; return false; });
  }
  function ov(field) { return readF(st.oel, field); }
  function ovErro(field, msg) { fieldErro(st.oel, field, msg); }
  function salvarData() {
    if (st.modal.criando) { st.modal.criando.then(function (ok) { if (ok && st.oel) salvarData(); }); return; }
    ovErro('dfTipo', ''); ovErro('dfTitulo', ''); ovErro('dfDia', ''); ovErro('dfMes', '');
    /* o aviso do dia e mes sai junto com os outros; a regiao viva esvazia sem anunciar,
       e o aviso que o salvar mostrar e lido pelo foco no Dia, sem repetir nela (T7-6) */
    st.modal.dm = ''; slot(st.oel, 'df-viva').textContent = '';
    /* T7-1g, T7-1h, T7-7b e T7-8 (dono, 31/10): um erro por vez, nesta ordem. Sem
       ocasiao, o foco vai ao primeiro chip, que sobe a tela ate eles no celular.
       O campo vazio so e erro na "Outra"; nas outras ocasioes vale o nome montado. */
    var bt = st.oel.querySelectorAll('[data-act="df-tipo"]'), marcado = st.oel.querySelector('[data-act="df-tipo"][aria-checked="true"]');
    var titulo = ov('dfTitulo').slice(0, 80), diaTxt = ov('dfDia'), dia = parseInt(diaTxt, 10), mes = parseInt(ov('dfMes'), 10);
    if (!marcado) { ovErro('dfTipo', T.val_data_tipo); bt[0].focus(); return; }
    if (!titulo) { if (G(marcado, 'data-tipo') === 'outra') { ovErro('dfTitulo', T.val_data_titulo); return; } titulo = nomeMontado(st.oel); }
    if (!diaTxt) { ovErro('dfDia', T.val_data_dia_vazio); return; }
    /* T7-7 (dono, 01/11): o Dia digitado aceita so um ou dois algarismos (o parseInt aceitava "1a") */
    if (!/^\d{1,2}$/.test(diaTxt) || !(dia >= 1 && dia <= 31)) { ovErro('dfDia', T.val_data_dia); return; }
    if (!(mes >= 1 && mes <= 12)) { ovErro('dfMes', T.val_data_mes); return; }
    if (dia > diasNoMes(mes)) { ovErro('dfDia', st.modal.dm = erroDiaMes(st.oel)); return; }
    /* T7-5: o ano saiu do corpo; o PUT e parcial e mantem o ano gravado, e o POST grava null */
    var dados = { titulo: titulo, tipo: st.modal.tipo, dia: dia, mes: mes, presenteadoId: st.modal.vinculo || null, lembreteAtivo: !!st.modal.lembrete };
    var editId = st.modal.editId;
    var acendeu = dados.lembreteAtivo && st.perfil && st.perfil.preferencias && !st.perfil.preferencias.emailLembretes;
    if (editId) {
      var d = byId(st.datas, editId); var antes = {};
      Object.keys(dados).forEach(function (k) { antes[k] = d[k]; d[k] = dados[k]; });
      persistir(function () { return req('PUT', '/datas/' + editId, dados); }, function () { Object.keys(antes).forEach(function (k) { d[k] = antes[k]; }); renderView(); }).then(function (r) { depoisDoPutData(editId, r); }, function () {});
    } else {
      var tmp = { id: 'tmp_' + Date.now() }; Object.keys(dados).forEach(function (k) { tmp[k] = dados[k]; });
      st.datas.push(tmp);
      /* T6-8 (dono, 31/10): a data cadastrada pelo painel do pedido volta marcada
         nele, so quando continua sendo da pessoa do pedido (a rota nao confere, a
         trava e esta); o pedido e gravado com o id do servidor, sem aviso proprio */
      var ped = st.modal.pedidoId ? byId(st.pedidos, st.modal.pedidoId) : null, t = tmp.id;
      var marca = ped && ped.presenteadoId && ped.presenteadoId === dados.presenteadoId, ad = marca && (ped.dataImportanteId || null);
      if (marca) ped.dataImportanteId = t;
      persistir(function () { return req('POST', '/datas', dados); }, function () {
        st.datas = st.datas.filter(function (x) { return x !== tmp; });
        if (marca && ped.dataImportanteId === t) ped.dataImportanteId = ad;
        renderView();
      }).then(function (r) {
        if (!r || !r.id) return;
        tmp.id = r.id;
        /* T6-14: a data da compra que a ocasiao absorveu sai; com o pedido a marcar,
           os pedidos sao relidos depois da marcacao, para nao cruzar com ela */
        var vm = marca && ped.dataImportanteId === t;
        novasDatas(r, vm);
        if (vm) { ped.dataImportanteId = ad; setVinculoData(ped.id, r.id, 1); }
      });
    }
    if (acendeu) st.perfil.preferencias.emailLembretes = true; // J16: backend acende sozinho
    fecharOverlay(); renderView();
    if (acendeu) toast(T.toast_acender, { acaoRot: T.acao_ajustar, acao: function () { irVista('preferencias'); } });
    else toast(editId ? T.toast_data_atualizada : T.toast_data_salva);
  }

  /* ---------- quiz ---------- */
  /* feitas: as respostas tocadas nesta rodada (T8-7 e T8-10) */
  function abrirQuiz(pid) {
    if (!pid) return;
    st.quiz = { pid: pid, passo: 0, feitas: [] };
    var m = clone('modal-quiz');
    abrirOverlay(m, 'quiz', fecharQuiz);
    renderQuizPasso();
  }
  function renderQuizPasso() {
    var m = st.oel; if (!m) return;
    var p = acharP(st.quiz.pid) || { nome: '' };
    var n = st.quiz.passo + 1;
    setText(m, 'sobre', fmt(T.quiz_sobre, { n: (p.nome || '').toUpperCase() }));
    var prog = slot(m, 'progresso'); if (prog) prog.style.width = Math.round((st.quiz.passo / 4) * 100) + '%';
    setText(m, 'passo', fmt(T.quiz_passo, { a: n, b: 4 }));
    setText(m, 'pergunta', T['q' + n + '_pergunta']);
    var ops = slot(m, 'opcoes'); limpar(ops);
    for (var k = 1; k <= 3; k++) {
      var b = clone('quiz-opcao'); b.textContent = T['q' + n + '_o' + k + '_r']; b.setAttribute('data-i', k); ops.appendChild(b);
    }
  }
  /* T8-6 (dono, 31/10): a resposta nova substitui a anterior da mesma pergunta, e o
     "Pular essa" mantem a anterior. O POST manda o numero da pergunta; o servidor
     revoga a resposta com a chave dela e devolve o id em revogadoId. A resposta
     gravada antes da chave (sem `pergunta`) e reconhecida pela pessoa e pelo fim do
     texto, o fato de uma das 3 opcoes (o comeco e o nome, que pode ter mudado), e
     sai pelo DELETE de sempre, so depois de a nova gravar. Sem revogadoId na
     resposta (o servidor de antes), a nova fica sem chave e a proxima troca vai
     pelo texto. Na falha, a nova sai e a anterior volta. */
  function daPergunta(f, pid, n) {
    if (f.presenteadoId !== pid || f.origem !== 'conta') return false;
    if (f.pergunta != null) return f.pergunta === n;
    for (var k = 1; k < 4; k++) { var x = ' ' + T['q' + n + '_o' + k + '_fato']; if ((f.texto || '').slice(-x.length) === x) return true; }
    return false;
  }
  function quizEscolher(k) {
    var q = st.quiz, pid = q.pid, p = acharP(pid) || { nome: '' }, n = q.passo + 1;
    var texto = p.nome + ' ' + T['q' + n + '_o' + k + '_fato'], cat = QUIZ_CAT[q.passo] || 'gosto';
    var velhas = st.fatos.filter(function (f) { return daPergunta(f, pid, n); });
    var tmp = { id: 'tmp_' + Date.now(), texto: texto, categoria: cat, origem: 'conta', presenteadoId: pid, pergunta: n };
    st.fatos = [tmp].concat(st.fatos.filter(function (f) { return velhas.indexOf(f) < 0; }));
    q.feitas.push(tmp);
    persistir(function () { return req('POST', '/fatos', { texto: texto, categoria: cat, presenteadoId: pid, pergunta: n }); }, function () {
      st.fatos = st.fatos.filter(function (x) { return x !== tmp; }).concat(velhas.filter(function (x) { return st.fatos.indexOf(x) < 0; }));
    }).then(function (r) {
      if (r.id) tmp.id = r.id;
      if (r.revogadoId === undefined) tmp.pergunta = null;
      velhas.forEach(function (f) { if (f.pergunta == null && !/^tmp_/.test(f.id)) req('DELETE', '/memoria/' + f.id).catch(function () {}); });
      if (r.revogadoId) st.fatos = st.fatos.filter(function (f) { return f.id !== r.revogadoId; });
    }, function () {});
    avancarQuiz();
  }
  function avancarQuiz() {
    if (++st.quiz.passo < 4) renderQuizPasso();
    else fecharQuiz(1);
  }
  /* T8-7 e T8-10 (dono, 31/10): fechar as perguntas (no fim, no X, tocando fora ou
     com Esc) redesenha a tela de onde elas abriram (a ficha ou a aba O Curador)
     quando houve resposta, e o foco vai ao botao das perguntas da pessoa, que o
     redesenho trocou. O aviso do fim so sai quando ficou alguma resposta da rodada
     (a que falhou ja saiu de st.fatos); com as 4 puladas, fecha sem aviso. */
  function fecharQuiz(fim) {
    var q = st.quiz; st.quiz = null; fecharOverlay();
    if (!q || !q.feitas.length) return;
    renderView();
    var b = contentEl && contentEl.querySelector('[data-act="iniciar-quiz-pessoa"][data-id="' + q.pid + '"],[data-act="iniciar-quiz-dossie"]');
    if (b) b.focus();
    var p = acharP(q.pid);
    if (fim && q.feitas.some(function (f) { return st.fatos.indexOf(f) > -1; })) toast(fmt(T.toast_quiz_fim, { n: p ? p.nome : '' }));
  }

  /* ---------- toggle endereco/complemento no form (sem re-render) ---------- */
  function abrirEnd() { var f = contentEl.querySelector('[data-mwc-form]'); if (!f) return; cond(f, 'end-fechado', false); cond(f, 'end-aberto', true); }
  function abrirComp() { var f = contentEl.querySelector('[data-mwc-form]'); if (!f) return; cond(f, 'comp-fechado', false); cond(f, 'comp-aberto', true); }

  /* ---------- delegacao de eventos ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]'); if (!b) return;
    var act = G(b, 'data-act');
    e.preventDefault(); // todo elemento data-act e botao/link que este modulo controla
    var pedEl = b.closest('[data-mwc-modal]') ? null : b.closest('.mwc-ped');
    var pedId = pedEl ? G(pedEl, 'data-id') : null;
    var rowId = function () { var r = b.closest('[data-id]'); return r ? G(r, 'data-id') : null; };
    switch (act) {
      case 'ir': irVista(G(b, 'data-view')); break;
      case 'ir-vinhos': location.href = G(b, 'data-destino') || '/collections/vinhos'; break;
      case 'sair': location.href = root.getAttribute('data-logout-url') || '/'; break; // logout real, sem return_to (Shopify volta pro storefront)
      case 'erro-tentar': st.rt = false; boot(); break; // re-roda o boot completo (spec 1)
      case 'novo-presenteado': st.form = { editId: null }; irVista('presenteados'); break;
      /* T6-14: a ficha aberta pelo link da linha do lembrete guarda o pedido; o voltar
         dela leva a ele, com o painel aberto e o foco no link (o do navegador, nao) */
      case 'abrir-presenteado': st.volta = pedId && { o: pedId, p: G(b, 'data-id') }; irVista('presenteados', G(b, 'data-id')); break;
      case 'fechar-dossie': var vt = voltaPed(); st.volta = null; if (vt) { irVista('pedidos', null, vt); focoEm(vt, '[data-act="abrir-presenteado"]', 1); } else irVista('presenteados'); break;
      case 'editar-presenteado': st.form = { editId: st.dossieId }; st.dossieId = null; st._interno = true; location.hash = 'presenteados'; st.view = 'presenteados'; renderView(); marcarNav(); break;
      case 'remover-presenteado': var p = acharP(st.dossieId); if (p) removerComUndo('presenteado', p.id, fmt(T.toast_removi_presenteado, { n: p.nome })); break;
      case 'form-salvar': salvarPresenteado(); break;
      case 'form-cancelar': var ed = st.form && st.form.editId; st.form = null; if (ed) irVista('presenteados', ed); else renderView(); break;
      case 'form-abrir-endereco': abrirEnd(); break;
      case 'form-abrir-complemento': abrirComp(); break;
      case 'add-data': abrirDataModal({}); break;
      case 'add-data-dossie': abrirDataModal({ pid: st.dossieId }); break;
      case 'add-data-alvo': var o = byId(st.pedidos, pedId); abrirDataModal({ pid: o ? o.presenteadoId : null, pedidoId: pedId }); break;
      case 'editar-data': abrirDataModal({ editId: rowId() }); break;
      case 'remover-data': var d = byId(st.datas, rowId()); if (d) removerComUndo('data', d.id, fmt(T.toast_removi_data, { n: d.titulo })); break;
      case 'toggle-lembrete': toggleLembrete(b, rowId()); break;
      case 'remover-fato': removerComUndo('fato', rowId(), T.toast_esqueceu); break;
      case 'iniciar-quiz-dossie': abrirQuiz(st.dossieId); break;
      case 'iniciar-quiz-pessoa': abrirQuiz(G(b, 'data-id')); break;
      /* T6-13: o painel abre com o foco no primeiro chip e o "Pronto" devolve o foco ao botao do rodape */
      case 'abrir-vincular': st.vincAberto = pedId; st.vincNova = null; renderView(); focoEm(pedId, '.mwc-chip'); break;
      /* T6-9: o "Dizer para quem foi" do Painel chega a Pedidos com o painel daquele pedido aberto */
      case 'vincular-de-painel': var vp = G(b, 'data-id'); irVista('pedidos', null, vp); focoEm(vp, '.mwc-chip', 1); break;
      case 'fechar-vincular': st.vincAberto = null; st.vincNova = null; renderView(); focoEm(pedId, '[data-act="abrir-vincular"]:not([hidden])'); break;
      case 'pick-pessoa': fecharNova(); setVinculoPessoa(pedId, G(b, 'data-pid')); break;
      case 'pick-pessoa-nenhum': fecharNova(); setVinculoPessoa(pedId, null); break;
      case 'pick-data': fecharNova(); setVinculoData(pedId, G(b, 'data-did')); break;
      case 'pick-data-nenhuma': fecharNova(); setVinculoData(pedId, null); break;
      case 'novo-pelo-vincular': st.vincNova = pedId; renderView(); focoEm(pedId, '[data-field="vNovaNome"]'); break;
      case 'v-nova-salvar': novaPessoaPedido(byId(st.pedidos, pedId)); break;
      case 'repetir': case 'repetir-radar': repetir(G(b, 'data-vid'), G(b, 'data-titulo'), G(b, 'data-handle')); break;
      case 'repetir-pedido': repetirPedido(G(b, 'data-id'), b); break;
      case 'abrir-curador': abrirCurador(); break;
      case 'salvar-nome': salvarNome(); break;
      case 'foto-escolher': escolherFoto(); break;
      case 'foto-remover': removerFoto(); break;
      case 'foto-cancelar': cancelarFoto(); break;
      case 'toggle-pref': togglePref(b); break;
      case 'df-tipo': escolherTipo(b, 1); break;
      case 'df-vinculo': st.modal.vinculo = G(b, 'data-pid'); marcarVinculo(); atualizarNome(); break;
      case 'df-vinculo-nenhum': st.modal.vinculo = null; marcarVinculo(); atualizarNome(); break;
      case 'df-nova-pessoa': abrirNovaPessoaData(b); break;
      case 'df-nova-salvar': criarPessoaDaData(); break;
      case 'df-lembrete': st.modal.lembrete = !st.modal.lembrete; marcarLembrete(); break;
      case 'salvar-data': salvarData(); break;
      case 'fechar-data-modal': fecharOverlay(); st.modal = null; break;
      case 'quiz-escolher': quizEscolher(parseInt(G(b, 'data-i'), 10)); break;
      case 'quiz-pular': avancarQuiz(); break;
      case 'fechar-quiz': fecharQuiz(); break;
      case 'toast-acao': var f = toastEl && toastEl._acao; if (toastEl) toastEl._expira = null; limparToast(false); if (f) f(); break;
      case 'toast-fechar': limparToast(true); break;
    }
  });
  root.addEventListener('submit', function (e) { if (e.target.closest('[data-mwc-form]')) { e.preventDefault(); salvarPresenteado(); } });

  function salvarNome() {
    var el = contentEl.querySelector('[data-field="nomeExib"]'); if (!el) return;
    var nome = el.value.trim(); if (!nome) return;
    var antes = st.nome; st.nome = nome;
    var rn = palco.querySelector('.mwc-rail-nome'); if (rn) rn.textContent = nome;
    var ini = palco.querySelector('.mwc-rail-head .mwc-avatar-ini'); if (ini) ini.textContent = iniciais(nome);
    persistir(function () { return req('PUT', '/perfil', { nomeExibicao: nome }); }, function () { st.nome = antes; if (rn) rn.textContent = antes; });
    toast(T.toast_nome_atualizado);
  }

  lerRota(); // H2: o ?v da volta do login vira o # antes da porta, que o devolve no return_to
  boot();
})();
